(function () {
  'use strict';

  angular
    .module('skatingApp', [
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngRoute',
      'ngMaterial',
      'ngStorage',
      'ngResource',
      'firebase',
      'angularUtils.directives.dirPagination',
      'angulartics',
      'angulartics.google.analytics',
      'chart.js'
    ]);

})();

(function () {
  'use strict';

  angular
    .module('skatingApp')
    .directive('allWatches', allWatches);

  /** @ngInject */
  function allWatches() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/watches/allWatches.html',
      link: linkFunction
    };

    function linkFunction(scope) {
      scope.watches = watches;
      scope.half = Math.ceil(scope.watches.length / 2);
    }
  }

  var watches = [
    {
      id: 'fenix5plus',
      label: 'fēnix 3 en hoger',
      link: 'https://buy.garmin.com/nl-NL/NL/cRunning-p1.html?series=BRAND473&sorter=featuredProducts-desc'
    },
    {
      id: 'forerunner235',
      label: 'Forerunner 230/235 en hoger',
      link: 'https://buy.garmin.com/nl-NL/NL/cRunning-p1.html?series=BRAND481&sorter=featuredProducts-desc'
    },
    {
      id: 'vivoactive3',
      label: 'alle vívoactive modellen',
      link: 'https://buy.garmin.com/nl-NL/NL/cRunning-p1.html?series=BRAND562&sorter=featuredProducts-desc'
    },
    {
      id: 'edge-820',
      label: 'Edge 520/530, 820/30, 1000/1030 en Explore serie (voor baanwielrennen)',
      link: 'https://buy.garmin.com/nl-NL/NL/cCycling-p1.html?series=BRAND482&sorter=featuredProducts-desc'
    }
  ];

  //
  // var watchesOrg = [
  //   {
  //     id: 'forerunner230',
  //     label: 'Forerunner® 230',
  //     link: 'https://partnerprogramma.bol.com/click/click?p=1&t=url&s=43541&f=TXL&url=https%3A%2F%2Fwww.bol.com%2Fnl%2Fs%2Falgemeen%2Fzoekresultaten%2FN%2F14657%2Fsc%2Fsto_all%2Fsearchtext%2Fforerunner%2520230%2Findex.html%3Forigin%3D9&name=intro&subid=fr230'
  //   },
  //   {
  //     id: 'forerunner235',
  //     label: 'Forerunner® 235',
  //     link: 'https://partnerprogramma.bol.com/click/click?p=1&t=url&s=43541&f=TXL&url=https%3A%2F%2Fwww.bol.com%2Fnl%2Fs%2Falgemeen%2Fzoekresultaten%2FN%2F14657%2Fsc%2Fsto_all%2Fsearchtext%2Fforerunner%2520235%2Findex.html%3Forigin%3D9&name=intro&subid=fr235'
  //   },
  //   {
  //     id: 'forerunner630',
  //     label: 'Forerunner® 630',
  //     link: 'https://partnerprogramma.bol.com/click/click?p=1&t=url&s=43541&f=TXL&url=https%3A%2F%2Fwww.bol.com%2Fnl%2Fs%2Felektronica%2Fzoekresultaten%2FN%2F3136%2Ffilter_N%2F4294834766%2Fsc%2Fmedia_all%2Fsearchtext%2Fforerunner%2520630%2Findex.html&name=intro&subid=fr630'
  //   },
  //   {
  //     id: 'forerunner-735xt',
  //     label: 'Forerunner® 735XT',
  //     link: 'https://partnerprogramma.bol.com/click/click?p=1&t=url&s=43541&f=TXL&url=https%3A%2F%2Fwww.bol.com%2Fnl%2Fs%2Fsport-vrije-tijd%2Fzoekresultaten%2FN%2F14647%2Ffilter_Nf%2F12194%2BBTWN%2B40%2B500%2Fsc%2Fsto_all%2Fsearchtext%2Fforerunner%2520735xt%2Findex.html%3Fview%3Dlist&name=intro&subid=fr735xt'
  //   },
  //   {
  //     id: 'forerunner-920xt',
  //     label: 'Forerunner® 920XT',
  //     link: 'https://partnerprogramma.bol.com/click/click?p=1&t=url&s=43541&f=TXL&url=https%3A%2F%2Fwww.bol.com%2Fnl%2Fs%2Felektronica%2Fzoekresultaten%2FNtt%2Fforerunner%252B920-xt%2FN%2F3136%2FNty%2F1%2Fsearch%2Ftrue%2FsearchType%2Fqck%2FdefaultSearchContext%2Fmedia_all%2Fsc%2Fs_elec_all%2Findex.html&name=intro&subid=fr920xt'
  //   },
  //   {
  //     id: 'fenix3',
  //     label: 'fēnix® 3',
  //     link: 'https://partnerprogramma.bol.com/click/click?p=1&t=url&s=43541&f=TXL&url=https%3A%2F%2Fwww.bol.com%2Fnl%2Fs%2Fsport-vrije-tijd%2Fzoekresultaten%2FN%2F14648%2Ffilter_N%2F4289222315%2Fsc%2Fsto_all%2Fsearchtext%2Ffenix%25203%2Findex.html%3Fview%3Dlist&name=intro&subid=fenix3'
  //   },
  //   {
  //     id: 'fenix3HR',
  //     label: 'fēnix® 3 HR',
  //     link: 'https://partnerprogramma.bol.com/click/click?p=1&t=url&s=43541&f=TXL&url=https%3A%2F%2Fwww.bol.com%2Fnl%2Fs%2Fsport-vrije-tijd%2Fzoekresultaten%2FNtt%2Ffenix%252B3%252Bhr%2FN%2F14647%2FNty%2F1%2Fsearch%2Ftrue%2FsearchType%2Fqck%2FdefaultSearchContext%2Fmedia_all%2Fsc%2Fsto_all%2Findex.html&name=intro&subid=fenix3hr'
  //   },
  //   {
  //     id: 'fenix-chronos',
  //     label: 'fēnix® Chronos',
  //     link: 'https://buy.garmin.com/nl-NL/NL/sport-recreatie/wandelen/fenix-chronos/prod532035.html'
  //   },
  //   {
  //     id: 'vivoactive-hr',
  //     label: 'vívoactive® HR',
  //     link: 'https://partnerprogramma.bol.com/click/click?p=1&t=url&s=43541&f=TXL&url=https%3A%2F%2Fwww.bol.com%2Fnl%2Fs%2Felektronica%2Fzoekresultaten%2FN%2F3136%2Ffilter_Nf%2F12194%2BBTWN%2B240%2B280%2Fsc%2Fs_elec_all%2Fsearchtext%2Fvivoactive%2520HR%2Findex.html&name=intro&subid=vivoactivehr'
  //   },
  //   {
  //     id: 'vivoactive',
  //     label: 'vívoactive®',
  //     link: 'https://partnerprogramma.bol.com/click/click?p=1&t=url&s=43541&f=TXL&url=https%3A%2F%2Fwww.bol.com%2Fnl%2Fs%2Felektronica%2Fzoekresultaten%2FN%2F18165%2Ffilter_Nf%2F12194%2BBTWN%2B190%2B240%2Fsc%2Fs_elec_all%2Fsearchtext%2Fvivoactive%2Findex.html&name=intro&subid=vivoactive'
  //   }
  // ];

  // var watches = [
  //   {
  //     id: 'fenix5s',
  //     label: 'fēnix 5, 5S en 5X',
  //     search: '"fenix 5"'
  //   },
  //   {
  //     id: 'fenix3',
  //     label: 'fēnix 3 en 3HR',
  //     search: '"fenix 3"'
  //   },
  //   {
  //     id: 'vivoactive3',
  //     label: 'vívoactive 3',
  //     search: '"vivoactive 3"'
  //   },
  //   {
  //     id: 'vivoactive-hr',
  //     label: 'vívoactive HR',
  //     search: '"vivoactive HR"'
  //   },
  //   {
  //     id: 'forerunner235',
  //     label: 'Forerunner 230 en 235',
  //     search: 'forerunner 230 235'
  //   },
  //   {
  //     id: 'forerunner935',
  //     label: 'Forerunner 935',
  //     search: '"forerunner 935"'
  //   },
  //   {
  //     id: 'forerunner-735xt',
  //     label: 'Forerunner 735XT',
  //     search: '"forerunner 735xt"'
  //   },
  //   {
  //     id: 'edge-820',
  //     label: 'Edge 520, 820, 1000, 1030',
  //     search: 'edge'
  //   }
  // ];

  // watches.forEach(function(watch) {
  //   var url = 'https://buy.garmin.com/nl-NL/NL/p/603201';
  //   watch.link = 'https://prf.hn/click/camref:1100l3ndy/pubref:sh/destination:' + encodeURIComponent(url);
  // })
})();


(function () {
  'use strict';

  /**
   * Message of the day
   */
  angular
    .module('skatingApp')
    .directive('spinner', spinner);

  /** @ngInject */
  function spinner() {
    return {
      restrict: 'E',
      replace: true,
      template: '<p layout="row" layout-sm="column" layout-align="space-around">' +
      '<md-progress-circular md-mode="indeterminate" md-diameter="32"></md-progress-circular></p>'
    };
  }

})();

(function () {
  'use strict';

  /**
   * Add event to loading an image
   * http://stackoverflow.com/questions/17547917/angularjs-image-onload-event
   */
  angular
    .module('skatingApp')
    .directive('sbLoad', sbLoad);

  /** @ngInject */
  function sbLoad($parse) {
    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {
        var fn = $parse(attrs.sbLoad);
        elem.on('load', function (event) {
          scope.$apply(function () {
            fn(scope, {$event: event});
          });
        });
      }
    };
  }

})();

(function () {
  'use strict';

  /**
   * Message of the day
   */
  angular
    .module('skatingApp')
    .directive('mod', mod);

  /** @ngInject */
  function mod() {
    return {
      restrict: 'E',
      replace: true,
      template: '',
      template2: '<div layout-padding md-whiteframe="1"  layout="row">' +
      ' <md-icon class="material-icons md-warn md-hue-1 md-36" flex="1">info</md-icon>' +
      ' <span>Wegens wijzigingen op de MYLAPS site werkt de Schaatshorloge App tijdelijk niet. De verwachting' +
      ' is dat het binnen een paar dagen is opgelost.</span></div>'
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('skatingApp')
    .service('format', format)
    .filter('localized', localized)
    .filter('formatDate', formatDate)
    .filter('formatShortDate', formatShortDate)
    .filter('formatTime', formatTime);

  /** @ngInject */
  function format (moment) {
    var service = {
      asTime: asTime
    };

    return service;

    function asTime (ms, dec) {
      var duration = moment.duration(ms)
      if (angular.isUndefined(dec)) {
        dec = 2
      }
      var result = (duration.seconds() + duration.milliseconds() / 1000).toFixed(dec)
      if (duration.asMinutes() < 1) {
        return result
      }
      result = duration.minutes() + pad(result)
      if (duration.asHours() < 1) {
        return result
      }
      result = Math.floor(duration.asHours()) + pad(result)
      return result;
    }

    function pad (num) {
      return (/^\d{2}/.test(num) ? ':' : ':0') + num
    }

  }

  /** @ngInject */
  function formatTime (format) {
    return function (op, dec) {
      return format.asTime(op, dec);
    }
  }

  /** @ngInject */
  function localized (moment) {
    return function (datetime, format) {
      datetime = fixTime(datetime)
      return moment(datetime).format(format);
    }
  }

  /** @ngInject */
  function formatDate (moment) {
    return function (date) {
      return moment(date).format('LL');
    }
  }

  /** @ngInject */
  function formatShortDate (moment) {
    return function (date) {
      return moment(date).format('ll');
    }
  }

  /**
   *  Ensure ts is Date
   * @param ts
   * @returns {*}
   */
  function fixTime (ts) {
    var nowSeconds = Date.now() / 1000
    switch (typeof ts) {
      case 'object' :
        return ts;
      case 'number' :
        if (ts < nowSeconds * 10) {
          ts *= 1000
        }
      // falls through
      default :
        return new Date(ts);
    }
  }

})();

(function () {
  'use strict';

  /**
   * Add event to loading an image
   * http://stackoverflow.com/questions/17547917/angularjs-image-onload-event
   */
  angular
    .module('skatingApp')
    .directive("contenteditable", contentEditable);

  /** @ngInject */
  function contentEditable () {
    return {
      restrict: "A",
      require: "ngModel",
      link: function (scope, element, attrs, ngModel) {

        function read () {
          ngModel.$setViewValue(element.html());
        }

        ngModel.$render = function () {
          element.html(ngModel.$viewValue || "");
        };

        element.bind("blur keyup change", function () {
          scope.$apply(read);
        });

      }
    };
  }

})();

(function () {
  'use strict'

  // Initialize Firebase

  angular
    .module('skatingApp')
    .factory('User', UserFactory)

  /** @ngInject */
  function UserFactory ($log, $resource, $q, $http, Config, $rootScope, $mdToast, $analytics) {

    var User = $resource(Config.apiUrl + 'user/:id', { id: '@_id' }, {
      registerWatch: { method: 'POST', url: Config.apiUrl + 'user/:id/watch', params: { id: '@_id' } }
    });

    var service = {
      auth: auth,
      update: update,
      signout: signout,
      registerWatch: registerWatch,
      agree: agree,
      extend: extend,
      cancel: cancel
    }

    var watcher = $rootScope.$watch('currentUser.transponder', function (val, old) {
      if (old && val && !angular.equals(val, old)) {
        update().then(function () {
          $analytics.eventTrack('update', { category: 'transponder' })
          $mdToast.showSimple('De transponder is geregistreerd.')
          return true
        })
      }
    })

    $rootScope.$on('$destroy', watcher)

    return service

    function auth (data) {
      return getUser(data).then(function (user) {
        service.currentUser = user
        $rootScope.currentUser = user
        $rootScope.$broadcast('login', user)
      }, function() {
        $rootScope.currentUser = false
      })
    }

    function update () {
      if (service.currentUser) {
        return service.currentUser.$save()
      }
    }

    function signout () {
      $rootScope.currentUser = false
      $rootScope.$broadcast('signout')
      delete service.currentUser
    }

    function registerWatch (code) {
      return service.currentUser.$registerWatch({ code: code });
    }

    function agree () {
      $http.post(getUrl(service.currentUser._id, 'agree')).then(function (result) {
        Object.assign(service.currentUser, result.data)
      })
    }

    function cancel () {
      return $http.delete(getUrl(service.currentUser._id)).then(function(response) {
        $log.log(response)
      })
    }

    function getUrl (id, action) {
      var url = Config.apiUrl + 'user'
      if (id) {
        url += '/' + id
        if (action) {
          url += '/' + action
        }
      }
      return url
    }

    function getUser(data) {
      var json = data.toJSON();
      var userData = {
        uid: json.uid,
        providerData: json.providerData,
        kd: json.stsTokenManager.accessToken,
        v: json.apiKey
      };
      var newUser = new User(userData)
      return newUser.$save()
    }

    function extend () {
      return $q(function (resolve, reject) {
        if (service.currentUser) {
          $http.post(getUrl(service.currentUser._id) + '/extend').then(function (result) {
            if( result.status === 200 ) {
              resolve(result.data)
            } else {
              reject(result.statusText)
            }
          })
        } else {
          reject('No valid user')
        }
      })
    }
  }
})
();

(function () {
  'use strict';

  angular
    .module('skatingApp')
    .directive('skateTrackStatus', TrackStatus);

  /** @ngInject */
  function TrackStatus() {
    var directive = {
      restrict: 'A',
      scope: {
        status: '@skateTrackStatus'
      },
      template: '{{icon}}<md-tooltip>{{label}}</md-tooltip>',
      link: linkFunc
    };

    return directive;

    function linkFunc(scope, elem) {
      var vm = scope;

      switch (vm.status) {
        case 'offline':
          vm.class = 'md-accent md-hue-1';
          vm.icon = 'remove_circle';
          vm.label = 'Offline';
          break;
        case 'online':
          vm.class = 'md-primary md-hue-1';
          vm.icon = 'pause_circle_filled';
          vm.label = 'Online';
          break;
        case 'active':
          vm.class = 'md-primary';
          vm.icon = 'play_circle_filled';
          vm.label = 'Actief';
          break;
      }

      elem.addClass('material-icons md-24').addClass(vm.class).attr('aria-label', vm.label);
    }
  }

})();

(function () {
  'use strict';

  // Initialize Firebase

  angular
    .module('skatingApp')
    .factory('Tracks', Tracks);

  /** @ngInject */
  function Tracks($log, $resource, Config) {
    var service = {
      sport:'IceSkating',
      getLocations: getLocations,
      identifier: identifier
    };
    getLocations();
    return service;

    function getLocations(sport) {
      if( angular.isDefined(sport)) {
        service.sport = sport === 'all' ? '' : sport;
      }
      var url = Config.apiUrl + 'tracks?sport=' + service.sport;
      service.data = $resource(url).get();
      service.data.$promise.then(function(data) {
        service.locations = data.locations;
        service.countries = getCountries(data);
        service.locations.sort(locationSort);
      });
      return service.data.$promise;
    }

    function getCountries(data) {
      var result = {};
      data.locations.forEach(function (loc) {
        loc.link = loc.link.replace( /^\/\w+\//, 'http://www.mylaps.com/nl/');
        if (angular.isUndefined(result[loc.country])) {
          result[loc.country] = {
            count: 1
          }
        } else {
          result[loc.country].count++;
        }
      });
      data.countries.forEach(function (country) {
        if (result[country.key]) {
          result[country.key].label = country.nl;
        }
      });
      return result;
    }

    function locationSort(a, b) {
      if( a.name < b.name) {
        return -1;
      }
      if( a.name > b.name) {
        return 1;
      }
      return Math.sign( parseInt(b.id, 10) - parseInt(a.id, 10));
    }

    function identifier(track) {
      return track.id + ' ' + track.name;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('skatingApp')
    .directive('skateTrackLine', trackLine);

  /** @ngInject */
  function trackLine() {
    var directive = {
      restrict: 'A',
      scope: {
        track: '=skateTrackLine'
      },
      templateUrl: 'app/components/tracks/trackline.html',
      controller: trackLineController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

  }

  /** @ngInject */
  function trackLineController(Tracks) {
    var vm = this;

    switch (vm.track.status) {
      case 'offline':
        vm.class = 'md-accent md-hue-1';
        vm.icon = 'remove_circle';
        vm.label = 'Offline';
        break;
      case 'online':
        vm.class = 'md-primary md-hue-1';
        vm.icon = 'pause_circle_filled';
        vm.label = 'Online';
        break;
      case 'active':
        vm.class = 'md-primary';
        vm.icon = 'play_circle_filled';
        vm.label = 'Actief';
        break;
    }

    vm.country = Tracks.countries && Tracks.countries[vm.track.country].label;
  }

})();

/**
 * Basic function for simulating a track-- addlap, reset, save and return data
 */
(function () {
  'use strict';

  angular
    .module('skatingApp')
    .factory('trackSimulator', trackSimulator);

  /** @ngInject */
  function trackSimulator($log, $http, $rootScope, $mdToast, Config) {

    var expiryTime = 300 * 1000;

    var service = {
      data: {
        active: false,
        laps: []
      },
      addLap: addLap,
      reset: reset
    };

    return service;

    function addLap(preset) {
      var now = (new Date()).getTime();

      // Lap expired?
      if (service.data.active && service.data.lastTime < now - expiryTime) {
        service.data.active = false;
        $mdToast.show($mdToast.simple().textContent('Sessie verlopen, opnieuw gestart'));
      }
      // Start new session if not active
      if (!service.data.active) {
        service.data.active = true;
        service.data.startTime = now;
        service.data.laps = [];
        service.data.lastTime = now;
        save();
        return 0;
      }
      var lapTime = preset || (now - service.data.lastTime);
      var numLaps = service.data.laps.length;
      // Check for best lap
      if (numLaps === 0 || lapTime < service.data.bestLap) {
        service.data.bestLap = lapTime;
      }
      var totalTime = numLaps === 0 ? 0 : service.data.laps[numLaps - 1].totalTime;
      service.data.laps.push({
        lapTime: lapTime,
        totalTime: totalTime + lapTime
      });
      service.data.lastTime = now;
      save();
      return service.data.laps.length;
    }

    function reset() {
      service.data.active = false;
      save();
    }

    function save() {
      if ($rootScope.currentUser) {
        var id = $rootScope.currentUser._id;
        var uri = Config.apiUrl + 'simulator/' + id;
        $http.post(uri, service.data);
      }
    }
  }
})();

/**
 * Extends trackSimulator with delayed and automatic laps
 */
(function () {
    'use strict';

    angular
      .module('skatingApp')
      .factory('autoSimulator', autoSimulator);

    /** @ngInject */
    function autoSimulator(trackSimulator, $timeout ) {

      var service = {
        data: trackSimulator.data,
        addLap: addLap,
        reset: reset,
        setLapSecs: setLapSecs,
        setDelay: setDelay,
        start: start,
        stop: stop,
        getProgress: getProgress,
        getCurrentTime: getCurrentTime,
        setLaps: setLaps
      };

      var auto = false; // Flag indicating auto-repeat laps
      var lapSecs;      // Number of seconds per lao
      var autoPromise;  // Promise to be resolved when end of time
      var currentStart;
      var currentLap;
      var presetLaps;

      /**
       * Add a new lap, start timer if auto-lap
       */
      function addLap(laptime) {
        var numLaps = trackSimulator.addLap(laptime);
        currentStart = now();
        if (auto) {
          start(true);
        } else if( presetLaps ) {
          if (numLaps < presetLaps.length) {
            currentLap = presetLaps[numLaps]
            autoPromise = $timeout(function () {
              addLap(currentLap)
            }, currentLap);
          } else {
            reset();
          }
        }
      }

      function reset() {
        trackSimulator.reset();
        currentLap = 0;
        stop();
      }

      /**
       * Start auto-laps, start new lap
       */
      function start(byAuto) {
        auto = true;
        var delay = lapSecs + Math.random();
        if( byAuto ) {
          setDelay(delay);
        } else {
          var thisLap = service.data.active ? now() - currentStart : -1;
          setDelay(delay, thisLap )
        }
      }

      /**
       * Stop auto-laps
       */
      function stop() {
        cancelPromise();
        auto = false;
      }

      /**
       * Set number of seconds for auto-lap
       * @param tSec
       */
      function setLapSecs(nSec) {
        lapSecs = nSec;
      }

      /**
       * Set delay in seconds for next lap
       * @param tSec
       */
      function setDelay(tSec, thisLap) {
        currentLap = Math.floor(1000 * tSec);
        setPromise(currentLap, thisLap);
      }

      /**
       * Get progress of current lap
       * @returns {number}   between 0 and 1
       */
      function getCurrentTime() {
        return now() - service.data.lastTime;
      }

      /**
       * Get progress of current lap
       * @returns {number}   between 0 and 1
       */
      function getProgress() {
        return currentLap && (now() - currentStart) / currentLap;
      }

      function setLaps(laps) {
        presetLaps = laps;
      }

      function setPromise(time, thisLap) {
        cancelPromise();
        if( thisLap === -1 || thisLap > time) {
          addLap();
          return;
        }
        if( angular.isUndefined(thisLap)) {
          thisLap = 0;
          currentStart = now()
        }
        autoPromise = $timeout(addLap, time - thisLap);
      }

      function cancelPromise() {
        if (autoPromise) {
          $timeout.cancel(autoPromise);
        }
      }

      function now() {
        return new Date().getTime();
      }

      return service;
    }
  })();

(function () {
  'use strict'

  // Initialize Firebase

  angular
    .module('skatingApp')
    .factory('Payments', PaymentsFactory)

  /** @ngInject */
  function PaymentsFactory ($log, $http, Config) {

    var service = {
      get: get,
      list: [],
      update: update,
      status: 'none',
      max: 10
    }

    return service

    function get (paymentId, wait) {
      var url = Config.apiUrl + 'payments/' + paymentId + (wait ? '?max=' + service.max : '')
      return $http.get(url).then(function (response) {
        return response.data
      })
    }

    function update() {
      service.status = 'loading'
      return $http.get(Config.apiUrl + 'payments').then(function (response) {
        service.list = response.data || []
        service.status = service.list.length > 0 ? 'list' : 'none'
      }, function(err) {
        $log.log(err)
        service.list = []
        service.status = 'none'
      })
    }
  }
})
();

(function () {
  'use strict';

  angular
    .module('skatingApp')
    .directive('navbar', navbar);

  /** @ngInject */
  function navbar($location) {
    return {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      link: function (scope) {
        scope.goto = function (link) {
          $location.path(link);
        };
        scope.currentNavbarPage = $location.path().slice(1) || 'intro';
      }
    };
  }


})();

(function() {
  'use strict';

  angular
    .module('skatingApp')
    .directive('social', social);

  /** @ngInject */
  function social() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/footer/social.html'
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('skatingApp')
    .directive('siteLinks', siteLinks);

  /** @ngInject */
  function siteLinks() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/footer/siteLinks.html'
    };

  }

})();

(function () {
  'use strict';

  // Initialize Firebase

  angular
    .module('skatingApp')
    .service('Config', Config);

  /** @ngInject */
  function Config($location) {

    if( $location.port() >=  1024 ) {
      this.apiUrl = '//' + $location.host() + ':8080/api/';
    } else {
      this.apiUrl = '/api/';
    }
  }

})();




(function () {
  'use strict';

  /**
   * Message of the day
   */
  angular
    .module('skatingApp')
    .directive('logStatus', logStatus);

  /** @ngInject */
  function logStatus(Auth) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/components/auth/logstatus.html',
      link: function (scope) {
        scope.message = 'Je moet eerst inloggen'
        scope.login = Auth.login
        scope.accept = Auth.accept
      }
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('skatingApp')
    .directive('authMenu', authMenu);

  /** @ngInject */
  function authMenu(Auth) {
    return {
      restrict: 'E',
      templateUrl: 'app/components/auth/authmenu.html',
      replace: true,
      link: linkFunc
    };

    function linkFunc(scope) {
      scope.auth = Auth;
      scope.imageLoaded = false;
    }
  }

})();




(function () {
  'use strict';

  // Initialize Firebase
  var fbConfig = {
    apiKey: "AIzaSyBnNo1H8OtTyrYBFjhI89NfNTtPLu-meZg",
    authDomain: "speedskatingapp.firebaseapp.com",
    databaseURL: "https://speedskatingapp.firebaseio.com",
    storageBucket: "speedskatingapp.appspot.com"
  };
  /*global firebase */
  firebase.initializeApp(fbConfig);

  angular
    .module('skatingApp')
    .factory('Auth', Auth);

  /** @ngInject */
  function Auth($log, $firebaseAuth, $mdDialog, $mdToast, $document, $rootScope, $location, User, $analytics) {
    var service = {
      login: login,
      accept: accept,
      signOut: signOut,
      account: account
    };

    var auth = $firebaseAuth();

    // any time auth status updates, add the user data to scope
    auth.$onAuthStateChanged(function (authData) {
      if( authData) {
        if( authData.providerData[0].email ) {
          $analytics.eventTrack('login', {
            category: 'auth',
            label: authData.providerData[ 0 ].providerId
          });
          User.auth(authData);
        } else {
          $analytics.eventTrack('no email', {
            category: 'auth',
            label: authData.providerData[ 0 ].providerId
          });
          noEmail(authData)
        }
      } else {
        delete service.user
        $rootScope.currentUser = false
      }
    });

    function login(ev) {
      $mdDialog.show({
        controller: LoginController,
        templateUrl: 'app/components/auth/login.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false
      })
    }

    function LoginController($scope, $mdDialog) {
      $scope.status = 'login';  // or 'reset' or 'register'
      $scope.user = {};
      $scope.hide = function () {
        $mdDialog.hide();
      };
      $scope.cancel = function () {
        $mdDialog.cancel();
      };
      $scope.about = function () {
        $mdDialog.cancel();
        $location.path('/about');
      };
      $scope.loginWith = function (provider) {
        auth.$signInWithPopup(provider)
          .then(function () {
            $analytics.eventTrack('register', {category: 'auth', label: provider});
            $mdDialog.hide(provider);
          })
          .catch(function (error) {
            $mdToast.showSimple("Aanmelden mislukt: " + error);
            $log.error("Authentication failed:", error);
          });
      };
    }

    function accept(ev) {
      $mdDialog.show({
        controller: AcceptController,
        templateUrl: 'app/components/auth/accept.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false
      })
    }

    function AcceptController($scope, $mdDialog) {
      $scope.account = {
        submit: function() {
          $analytics.eventTrack('accept', {category: 'auth'});
          User.agree();
          $mdDialog.cancel();
        },
        agreed: false
      }
      $scope.hide = function () {
        $mdDialog.hide();
      };
      $scope.cancel = function () {
        $mdDialog.cancel();
      };
    }

    function signOut() {
      $analytics.eventTrack('signout', {
        category: 'auth',
        label: $rootScope.currentUser.providerId
      });
      auth.$signOut();
      User.signout();
    }

    function account() {
      $location.path('/account');
    }

    function noEmail(authData) {
      $mdDialog.show(
        $mdDialog.alert()
          .parent(angular.element($document.body))
          .clickOutsideToClose(true)
          .title('Fout bij inloggen')
          .textContent('Het emailadres ontbreekt bij de gegevens van ' + authData.providerData[ 0 ].providerId)
          .ariaLabel('Geen emailadres fout')
          .ok('Sluiten')
      );
    }
    return service;
  }

})();




(function () {
  'use strict';

  angular
    .module('skatingApp')
    .directive('chart', chart);

  /** @ngInject */
  function chart ($log, moment, format) {
    return {
      scope: {
        data: '='
      },
      restrict: 'E',
      templateUrl: 'app/components/chart/chart.html',
      link: linkFunction
    };

    function linkFunction (scope) {
      // Internal collection of data
      var data = {}
      var datasets = getDatasets()
      var series = Object.keys(datasets).filter(hasData)
      var hoverSession = 0

      /*global Chart */
      Chart.Tooltip.positioners = getPositioners()

      scope.options = getOptions()
      scope.sessionSelect = 0
      scope.sessionsList = scope.data.fit.sessions && scope.data.fit.sessions.map(function (session) {return session.idx})
      scope.legend = []

      scope.dataSelect = {};
      series.forEach(function (key) {
        scope.dataSelect[ key ] = true
        data[ key ] = []
        scope.legend.unshift({
          key: key,
          label: datasets[ key ].label,
          color: datasets[ key ].legendColor
        })
      })

      scope.onClick = function () {
        scope.$apply(chartClick)
      }

      scope.setSelectedData = function () {
        var keys = series.filter(function (key) {return scope.dataSelect[ key ]})
        scope.selectedData = keys.map(function (key) {return data[ key ]})
        scope.datasetOverride = keys.map(function (key) {return datasets[ key ]})
        scope.options.scales.yAxes.forEach(function (axis) {
          axis.display = showAxis(axis.id)
        })
      }
      scope.setSelectedSession = function (session) {
        if (angular.isDefined(session)) {
          scope.sessionSelect = session.toString()
        } else {
          session = Number(scope.sessionSelect)
        }
        var records = scope.data.fit.records
        if (records) {
          if (session !== 0) {
            records = records.filter(function (rec) { return rec.session && rec.session.idx === session})
          }
          scope.labels = fillData(records, data)
          scope.setSelectedData()
        }
      }

      scope.setSelectedSession()

      function fillData (records, data) {
        // reset current data
        var labels = []
        for (var key in data) {
          data[ key ] = []
        }
        data.lapTime = []
        data.lapNo = []
        data.session = []
        // Determine start of session
        var t0 = records[ 0 ].timestamp * 1000
        var startOfDay = moment(t0).startOf('day').valueOf()
        t0 -= startOfDay
        // Fill data
        records.forEach(function (r) {
          labels.push(new Date(r.timestamp * 1000 - t0));
          series.forEach(function (key) {
            data[ key ].push(key === 'speed' ? (r.lap && r.lap.speed) : r[ key ])
          })
          data.lapTime.push(r.lap && r.lap.lapTime);
          data.lapNo.push(r.lap && r.lap.idx);
          data.session.push(r.session && r.session.idx);
        })
        return labels
      }

      function getOptions () {
        return {
          animation: {
            duration: 0
          },
          tooltips: {
            intersect: false,
            displayColors: false,
            position: 'current',
            callbacks: {
              afterTitle: onAfterTitle,
              label: onLabel,
              afterBody: onAfterBody
            }
          },
          scales: {
            xAxes: [ {
              type: 'time',
              time: {
                displayFormats: {
                  minute: 'H:mm',
                  second: 'm:ss'
                },
                tooltipFormat: 'LTS'
              }
            } ],
            yAxes: [
              {
                id: 'y-axis-1',
                type: 'linear',
                display: true,
                position: 'left',
                scaleLabel: { labelString: 'km/u', display: true },
                ticks: { beginAtZero: false }
              },
              {
                id: 'y-axis-2',
                type: 'linear',
                display: true,
                position: 'right',
                scaleLabel: { labelString: 'slagen/minuut', display: true },
                ticks: { beginAtZero: true }
              }
            ]
          }
        }
      }

      function getPositioners() {
        return {
          current: function (elems, pos) {
            return { x: pos.x, y: pos.y }
          },
          bottom: function (elems, pos) {
            var yMax = elems[ 0 ]._yScale.bottom
            return { x: pos.x, y: yMax }
          },
          border: function (elems, pos) {
            var yMax = elems[ 0 ]._yScale.bottom
            var y = pos.y > yMax / 2 ? 0 : yMax
            return { x: pos.x, y: y }
          }
        }
      }

      function getDatasets () {
        return {
          cadence: {
            label: 'Cadans',
            yAxisID: 'y-axis-2',
            pointStyle: 'line',
            pointRadius: 2,
            fill: false,
            pointBorderWidth: 3,
            pointBorderColor: '#FF9800',
            legendColor: '#EF6C00',
            borderColor: 'transparent',
            showLines: false
          },
          heartRate: {
            label: 'Hartslag',
            yAxisID: 'y-axis-2',
            pointRadius: 0,
            fill: false,
            legendColor: '#F44336',
            borderColor: '#F44336'
          },
          speed: {
            label: 'Snelheid',
            yAxisID: 'y-axis-1',
            pointRadius: 0,
            legendColor: '#1565C0',
            borderColor: '#82B1FF',
            backgroundColor: '#BBDEFB',
            fill: true,
            stepped: true,
            tension: 0
          }
        }
      }

      function chartClick () {
        var currentSession = Number(scope.sessionSelect)
        var newSession = currentSession ? 0 : hoverSession
        scope.setSelectedSession(newSession)
      }

      function onAfterTitle (tooltipItems) {
        var result = []
        var session = data.session[ tooltipItems[ 0 ].index ]
        if (session) {
          result.push('Interval ' + session)
        }
        hoverSession = session
        var lapNo = data.lapNo[ tooltipItems[ 0 ].index ]
        if (lapNo) {
          result.push('Ronde ' + lapNo)
        }
        return result
      }

      function onLabel (tooltipItem, tooltipData) {
        var label = tooltipData.datasets[ tooltipItem.datasetIndex ].label
        var val = tooltipItem.yLabel
        if (angular.isNumber(val) && !Number.isInteger(val)) {
          val = val.toFixed(2)
        }
        return label + ': ' + val
      }

      function onAfterBody (tooltipItems) {
        var lapTime = data.lapTime[ tooltipItems[ 0 ].index ]
        if (lapTime) {
          return 'Rondetijd: ' + format.asTime(lapTime)
        }
      }

      function hasData (key) {
        if (key === 'speed') {
          return scope.data.fit.laps.length > 0;
        }
        if (!scope.data.fit.activity) {
          return false;
        }
        var sessionKey = key.replace(/^(\w)/, function (ch) {return 'max' + ch.toUpperCase() })
        return scope.data.fit.activity[ sessionKey ];
      }

      function showAxis (id) {
        return scope.datasetOverride.some(function (set) { return set.yAxisID === id })
      }
    }
  }

})
();


(function () {
  'use strict';

  // Initialize Firebase

  angular
    .module('skatingApp')
    .factory('Parser', Parser);

  /** @ngInject */
  function Parser () {
    var service = {
      process: process
    }
    var metrics = {}
    return service;

    function process (activity) {
      var fit = activity.fit
      var data = parseFit(fit)
      var startTime = data.sessions[ 0 ].startTime
      var endTime = data.activity.timestamp
      if (data.records && data.records[ 0 ]) {
        metrics = Object.assign({}, data.records[ 0 ])
        delete metrics.timestamp
      }
      addMissing(data.records, startTime, endTime)

      processRecords(data.records, 'lap', data.laps)
      processLaps(data, activity.trackLength)
      processSessions(data)
      processActivity(data, activity.trackLength)
      return data
    }

    /**
     * Read FIT message and parse in data structure with record, length, lap, session
     * @param fit
     * @returns {{}}
     */
    function parseFit (fit) {
      var def = {}
      var data = {}
      fit.forEach(function (f) {
        var type = f[ 0 ]
        var cat = f[ 1 ]
        var d = f.slice(2)
        if (cat === 'def') {
          def[ type ] = d
          data[ type ] = data[ type ] || []
        } else {
          var obj = zipObject(def[ type ], d)
          data[ type ].push(obj)
        }
      })
      var numLengths = data.length && data.length.length;
      if (numLengths > 0) {
        var lastLength = data.length[numLengths-1];
        var activity = {
          startTime: data.length[0].startTime,
          timestamp: lastLength.startTime + lastLength.lapTime / 1000
        }
        if (!data.lap || data.lap.length === 0) {
          data.lap = [activity];
        }
        if (!data.session || data.session.length === 0) {
          data.session = [activity];
        }
      }
      return {
        records: data.record,
        laps: data.length,
        sessions: data.lap,
        activity: data.session && data.session[ 0 ]
      }
    }

    /**
     * Combine array with keys and array with values
     * @param props
     * @param values
     * @returns {{}}
     */
    function zipObject (props, values) {
      var index = -1,
        length = props ? props.length : 0,
        result = {};

      if (length && !values && !angular.isArray(props[ 0 ])) {
        values = [];
      }
      while (++index < length) {
        var key = props[ index ];
        if (values) {
          result[ key ] = values[ index ];
        } else if (key) {
          result[ key[ 0 ] ] = key[ 1 ];
        }
      }
      return result;
    }

    /**
     * Fill in empty record before activity started and after ended
     * @param records
     * @param startTime
     * @param endTime
     */
    function addMissing(records, startTime, endTime) {
      if (endTime - startTime < 5) {
        return;
      }
      // Must have at least one record
      if (records.length === 0) {
        records.push({ timestamp: startTime + 5 });
      }
      var step = 5;
      var maxStep = step * 1.5;
      // Ensure last record near endTime
      var recordEnd = records[records.length - 1].timestamp;
      if (recordEnd + maxStep < endTime) {
        records.push({ timestamp: endTime });
      }
      // Insert records where gap more than maxStep
      var ts = startTime;
      for (var index = 0; index < records.length; index++) {
        if (ts + maxStep < records[index].timestamp) {
          records.splice(index, 0, { timestamp: ts + step });
        }
        ts = records[index].timestamp;
      }
    }

    /**
     * Create lap or session property in each record
     * @param data
     */
    function processRecords (records, key, data) {
      var index = 0
      var len = data.length

      records.forEach(function (r) {
        while (index < len && r.timestamp > tsEnd(data[ index ])) {
          index++
        }
        // Add item to record if beyond start time
        if (index < len && r.timestamp > data[ index ].startTime) {
          r[ key ] = data[ index ]
        }
      })
    }

    function tsEnd (item) {
      return angular.isDefined(item.lapTime) ?
        item.startTime + Math.ceil(item.lapTime / 1000) :
        item.timestamp
    }

    /**
     * Add speed, totalTime and index to lap
     * @param laps
     * @param length
     */
    function processLaps (data, length) {
      data.records.forEach(setLapRecordData)
      var totalTime = 0
      data.laps.forEach(function (lap, idx) {
        lap.speed = 3600 * length / lap.lapTime
        totalTime += lap.lapTime
        lap.totalTime = totalTime
        lap.idx = idx + 1
        setAverageData(lap.data)
      })
    }

    function setAverageData (data) {
      for (var key in metrics) {
        if (data && data[ key ] && data[ key ].count) {
          data[ key ].avg = Math.round(data[ key ].sum / data[ key ].count)
        }
      }
    }

    /**
     * Set data for laps, accumulate from record and calculate from lapTime
     * @param data
     */

    function setLapRecordData (record) {
      if (angular.isUndefined(record.lap)) {
        return
      }
      var lap = record.lap
      if (angular.isUndefined(lap.data)) {
        lap.data = {}
      }
      for (var key in metrics) {
        if (isNaN(record[ key ])) {
          continue
        }
        if (angular.isUndefined(lap.data[ key ])) {
          lap.data[ key ] = { sum: record[ key ], count: 1, max: record[ key ] }
        } else {
          lap.data[ key ].sum += record[ key ]
          lap.data[ key ].count++
          if (record[ key ] > lap.data[ key ].max) {
            lap.data[ key ].max = record[ key ]
          }
        }
      }
    }

    /**
     * Match length/laps and lap/sessions
     * @param data
     */
    function processSessions (data) {
      matchSessionsToLaps(data)
      data.sessions.forEach(function (session, idx) {
        session.idx = idx + 1
        session.data = addLapData(session.laps)
      })
      processRecords(data.records, 'session', data.sessions)
    }

    function matchSessionsToLaps (data) {
      var index = 0;
      data.sessions.forEach(function (session) {
        session.laps = []
        while (data.laps[ index ] && data.laps[ index ].startTime < session.startTime) {
          delete data.laps[ index ].session
          index++
        }
        while (data.laps[ index ] && tsEnd(data.laps[ index ]) <= session.timestamp) {
          data.laps[ index ].session = session
          session.laps.push(data.laps[ index ])
          index++
        }
      })
    }

    function addLapData (laps) {
      var data = {
        numLaps: laps.length,
        time: 0,
        bestLap: null
      }
      laps.forEach(function (lap) {
        data.time += lap.lapTime;
        if (!data.bestLap || lap.lapTime < data.bestLap) {
          data.bestLap = lap.lapTime
        }
        accumulate(data, lap)
      })
      if (laps.length > 0) {
        data.avgLap = data.time / data.numLaps
        setAverageData(data)
      }
      return data
    }

    function accumulate (data, item) {
      for (var key in metrics) {
        if (!item.data || !item.data[ key ]) {
          continue
        }
        if (angular.isUndefined(data[ key ])) {
          data[ key ] = { max: 0, sum: 0, count: 0 }
        }
        data[ key ].max = Math.max(data[ key ].max, item.data[ key ].max)
        data[ key ].sum += item.data[ key ].sum
        data[ key ].count += item.data[ key ].count
      }
    }

    function processActivity (data, length) {
      data.activity.laps = addLapData(data.laps)
      data.activity.sessions = addSessionData(data.sessions)
      data.columns = {}
      Object.keys(metrics).forEach( function(key) {
        var dataKey = 'max' + key[0].toUpperCase() + key.slice(1)
        data.columns[key] = !!data.activity[dataKey]
      })
      data.activity.maxSpeed = 3600 * length / data.activity.bestLap
      data.activity.avgSpeed = 3600 * length / data.activity.avgLap

    }

    function addSessionData (sessions) {
      var data = {
        numLaps: 0,
        time: 0,
        bestLap: null
      }
      sessions
        .filter(function (session) { return session.data.numLaps > 0})
        .forEach(function (session) {
          data.numLaps += session.data.numLaps
          data.time += session.data.time;
          if (!data.bestLap || session.data.bestLap < data.bestLap) {
            data.bestLap = session.data.bestLap
          }

          accumulate(data, session)
        })
      if (data.numLaps > 0) {
        data.avgLap = data.time / data.numLaps
        setAverageData(data)
      }
      return data
    }
  }

})();

(function () {
  'use strict';

  // Initialize Firebase

  angular
    .module('skatingApp')
    .factory('Activities', Activities);

  /** @ngInject */
  function Activities ($log, $resource, Config, Parser) {
    var url = Config.apiUrl + 'activities/:id'
    var source = $resource(url, { id: '@id' })
    return {
      list: source.query,
      get: get
    };

    function get (id) {
      return source.get({ id: id }).$promise.then(function (activity) {
        activity.trackLength = activity.track.trackLength - 4 * Math.PI;
        activity.fit = Parser.process(activity)
        return activity
      }, function (error) {
        return error.data
      })
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('skatingApp')
    .controller('StaticController', StaticController);

  /** @ngInject */
  function StaticController ($mdDialog, $mdMedia, $document) {
    var vm = this
    vm.showVideo = function (ev) {
      if($mdMedia('gt-xs')) {
        $mdDialog.show({
          controller: DialogController,
          templateUrl: 'app/static/video.html',
          parent: angular.element($document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: false   // Only for -xs, -sm breakpoints.
        });
        ev.preventDefault();
      }
    };
    return vm;
  }

  function DialogController($scope, $mdDialog) {
    $scope.cancel = function() {
      $mdDialog.cancel();
    };
  }

})();


(function () {
  'use strict';

  angular
    .module('skatingApp')
    .controller('SimulationController', SimulationController);

  /** @ngInject */
  function SimulationController($scope, autoSimulator, $localStorage, $interval, $analytics, $routeParams) {
    var vm = this;

    vm.storage = $localStorage.$default({
      auto: 10,
      mode: 'manual'
    });

    if (vm.storage.mode === 'list') {
      vm.storage.mode = 'manual';
    }

    if ($routeParams.laps) {
      var laps = $routeParams.laps.split(/[ \+]/).map(function (str) {
        return Math.round(1000 * parseFloat(str.replace(',', '.'), 10));
      });
      autoSimulator.setLaps(laps);
      if (laps && laps[0] > 0) {
        vm.storage.mode = 'list';
      }
    }

    $scope.$watch('sim.storage.auto', function (val) {
      autoSimulator.setLapSecs(val);
    });

    $scope.$watch('sim.storage.mode', function (val, old) {
      if (old) {
        $analytics.eventTrack('mode', { category: 'laps', label: val });
        autoSimulator.stop();
        vm.running = false;
      }
    });

    vm.toggle = toggle;
    vm.reset = reset;
    vm.addLap = function () {
      $analytics.eventTrack('add', { category: 'laps' });
      if( vm.storage.mode === 'list' ) {
        vm.running = true;
      }
      autoSimulator.addLap();
    };

    vm.service = autoSimulator;
    vm.running = false;

    vm.options = [{
      id: 'manual',
      label: 'handmatig'
    }, {
      id: 'auto',
      label: 'automatisch'
    }];

    function reset() {
      $analytics.eventTrack('reset', { category: 'laps' });
      autoSimulator.reset();
      vm.running = false;
    }

    function toggle() {
      if (vm.running) {
        $analytics.eventTrack('stop', { category: 'laps' });
        autoSimulator.stop();
      } else {
        $analytics.eventTrack('start', { category: 'laps' });
        autoSimulator.start();
      }
      vm.running = !vm.running;
    }

    $interval(function () {
      if (autoSimulator.data.active) {
        vm.thisLap = autoSimulator.getCurrentTime();
      }
      if (vm.running && vm.storage.mode !== 'manual') {
        vm.progress = autoSimulator.getProgress() * 100;
      }
    }, 100);
  }
})();

(function () {
  'use strict';

  angular
    .module('skatingApp')
    .controller('SettingsController', SettingsController);

  /** @ngInject */
  function SettingsController($scope, User, $mdToast, $q, $log, $analytics) {
    var vm = this;

    vm.user = User;

    var watchInput;
    $scope.$watch('settingsForm', function (val) {
      watchInput = val.watchCode;
      watchInput.$parsers.push(onlyDigits);
      watchInput.$validators.length = validLength;
      watchInput.$asyncValidators.code = validCode;
    });

    return vm;

    function onlyDigits(value) {
      if (value) {
        var parsed = value.replace(/\D+/g, '');
        return parsed;
      }
    }

    function validLength(modelValue) {
      var result = angular.isUndefined(modelValue) || modelValue.length === 8;
      return result;
    }

    function validCode(code) {
      if (angular.isUndefined(code)) {
        return $q.resolve(true);
      }
      watchInput.$setTouched();
      return User.registerWatch(code)
        .then(function () {
          var watches = User.currentUser.watches;
          $analytics.eventTrack('add', {category:'watch', label:watches[watches.length-1].type});
          $mdToast.showSimple("Het horloge is geregistreerd.");
          return true;
        })
        .catch(function (error) {
          $log.error('error', error);
          var reason = error.status === 404 ? 'notFound' : 'error';
          return $q.reject(reason);
        });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('skatingApp')
    .directive('skateSetWatches', setWatches);

  /** @ngInject */
  function setWatches(User, $analytics) {
    var directive = {
      restrict: 'E',
      scope: {
        watches: '='
      },
      templateUrl: 'app/settings/setWatches.html',
      controller: WatchesController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function WatchesController() {
      var vm = this;
      vm.remove = function(idx) {
        $analytics.eventTrack('remove', {category:'watch', label:vm.watches[idx].type});
        vm.watches.splice(idx,1);
        User.update();
      };

      vm.getTimestamp = function(id) {
        return new Date(parseInt(id.substring(0, 8), 16) * 1000);
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('skatingApp')
    .factory('Mylaps', Mylaps);

  /** @ngInject */
  function Mylaps ($log, $resource, $http, Config) {
    var url = Config.apiUrl + 'activities/mylaps/:id'
    var source = $resource(url, { id: '@id' })
    return {
      list: source.query,
      post: source.save
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('skatingApp')
    .controller('MylapsController', MylapsController);

  /** @ngInject */
  function MylapsController(Mylaps, $log, $location) {
    var vm = this;
    vm.loading = false;
    vm.list = [];
    vm.fetch = fetch;
    vm.import = importMylaps;

    var COUNT = 20;
    var offset = 0;
    fetch();

    function fetch() {
      vm.loading = true;
      delete vm.errorMessage;
      Mylaps.list({count: COUNT, offset: offset}).$promise
        .then(function(list) {
          vm.loading = false;
          vm.more = list.length === COUNT;
          if( list.length > 0) {
            vm.list = vm.list.concat(list.filter(withoutActivity));
            var last = list[list.length - 1];
            vm.limit = last.startTime;
            $log.log(vm.list.length, last, vm.limit);
          }
        }).catch(function(err) {
          vm.loading = false;
          vm.errorMessage = err.data.error;
        })
      offset += COUNT;
    }

    function importMylaps(id) {
      Mylaps.post({id:id}).$promise
        .then(function(result) {
          $location.path('/activities/' + result._id);
        })
        .catch($log.error);
    }

    function withoutActivity(act) {
      return !act.activity;
    }
  }
})
();

(function () {
  'use strict';

  angular
    .module('skatingApp')
    .controller('PaymentsController', PaymentsController);

  /** @ngInject */
  function PaymentsController ($routeParams, User, Payments) {
    var vm = this;

    vm.waiting = true
    vm.refetch = fetch
    vm.progress = false
    fetch()
    return vm;

    function fetch (wait) {
      vm.status = wait ? 'waiting' : 'loading'
      vm.progress = { mode: 'indeterminate' }
      Payments.get($routeParams.paymentId, wait)
        .then(function (data) {
          process(data, wait)
      })
    }

    function process (data, wait) {
      vm.status = data.status || data.updates[ 0 ].status
      vm.progress = false
      if (vm.status === 'paid') {
        Payments.update(true)
      } else if (wait) {
        vm.status = 'timeout'
      } else {
        fetch(true)
      }
    }
  }
})
();

(function () {
  'use strict';

  angular
    .module('skatingApp')
    .controller('MessageController', MessageController);

  /** @ngInject */
  function MessageController () {
    var vm = this
    vm.message = 'Goedenavond!'
    return vm;
  }
})();

(function () {
  'use strict';

  angular
    .module('skatingApp')
    .factory('Garmin', Garmin);

  /** @ngInject */
  function Garmin ($log, $resource, $http, Config) {
    var url = Config.apiUrl + 'activities/garmin/:id'
    var source = $resource(url, { id: '@id' }, {
      import: { method: 'POST', isArray: true }
    })
    return {
      get: get,
      import: importList
    };

    function get (id) {
      var result = source.get({ id: id })
      // result.$promise.then(function (info) {
      //   info.garmindId = id
      // })
      return result
    }

    function importList (list) {
      var result = source.import(list)
      return result.$promise
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('skatingApp')
    .controller('GarminController', GarminController);

  /** @ngInject */
  function GarminController (Garmin, $mdDialog) {
    var vm = this;
    vm.text = ''
    vm.links = []
    vm.loading = false

    vm.onChange = function () {
      var re = /https:\/\/connect\.garmin\.com\/modern\/activity\/(\d{9,})/g
      var match = vm.text.match(re) || []
      vm.links = match.map(linkInfo)
    }

    vm.hasChecked = function () {
      return vm.links.filter(function (item) { return item.checked }).length > 0
    }

    vm.import = function () {
      vm.loading = true
      var idList = vm.links
        .filter(function (link) { return link.checked})
        .map(function (link) {
          return {
            aid: link.info.activity._id,
            gid: link.info.garmin.id
          }
        })
      Garmin.import(idList).then(function (list) {
        list.forEach(function (item) {
          vm.links.filter(function (link) {
            return link.info.activity && link.info.activity._id === item._id
          }).forEach(function(link) {
            link.info.activity = item
            link.checked = false
          })
        })
        vm.loading = false
        alertDialog('De activiteiten zijn geïmporteerd',
          'Je kunt ze bekijken bij <b>Activiteiten</b> of doorgaan en meer activiteiten importeren.')
      })
    }

    vm.onClick = function (event) {
      event.stopPropagation()
      return false
    }
    return vm;

    function linkInfo (link) {
      var id = link.split('/').pop()
      var result = {
        link: link,
        info: Garmin.get(id)
      }
      result.info.$promise.then(function (info) {
        result.checked = info.activity && !info.activity.record
      }).catch(function (error) {
        result.info.error = error.status + ' ' + error.statusText
      })
      return result
    }

    function alertDialog (title, content) {
      $mdDialog.show(
        $mdDialog.alert()
          .clickOutsideToClose(true)
          .title(title)
          .htmlContent(content)
          .ariaLabel('Import finished alert')
          .ok('OK')
      );
    }

  }
})
();
(function () {
  'use strict';

  angular
    .module('skatingApp')
    .factory('Debug', Debug);

  /** @ngInject */
  function Debug ($http, Config) {

    return {
      searchUser: searchUser,
      userActivities: userActivities,
      userSessions: userSessions,
      sessionLogs: sessionLogs
    };

    function searchUser(pattern) {
      var url = Config.apiUrl + 'user/search/' + pattern;
      return $http.get(url)
    }

    function userActivities(uid) {
      var url = Config.apiUrl + 'user/' + uid + '/activities';
      return $http.get(url)
    }

    function userSessions(uid) {
      var url = Config.apiUrl + 'user/' + uid + '/sessions';
      return $http.get(url)
    }

    function sessionLogs(sid) {
      var url = Config.apiUrl + 'user/session/' + sid;
      return $http.get(url)
    }
  }

})();



(function () {
  'use strict';

  angular
    .module('skatingApp')
    .controller('DebugController', DebugController);

  /** @ngInject */
  function DebugController($scope, $log, $window, $mdToast, Debug) {
    var vm = this;

    vm.userPattern = 'oosterveen';
    vm.users = [];
    vm.activities = [];
    vm.sessions = [];
    vm.current = -1;
    vm.status = {};

    // $scope.$watch('ctrl.userPattern', function (val, old) {
    //   $log.log('changed?', val, old);
    //   vm.searchUser();
    // });

    vm.searchUser = function () {
      $log.log('Submitted', vm.userPattern);
      if (vm.userPattern.length < 3) {
        $mdToast.show(
          $mdToast.simple()
            .textContent('At least 3 characters')
        );
        return;
      }
      vm.users = [];
      vm.current = -1;
      vm.status = {
        users: 'loading'
      };
      Debug.searchUser(vm.userPattern).then(function (results) {
        vm.users = results.data.map((function (user) {
          user.string = angular.toJson(user, true);
          user.watchesStr = user.watches.map(function (w) {
            return w.type;
          }).join(', ');
          user.icon = statusIcon(user.account && user.account.status);
          return user;
        }));
        vm.status.users = vm.users.length > 0 ? 'ok' : 'none';
      });
    };

    vm.showCurrent = function (val, idx) {
      return vm.current === -1 || idx === vm.current;
    };

    vm.showLog = function (label, item) {
      $mdToast.show(
        $mdToast.simple()
          .textContent(label + ' logged to console')
          .hideDelay(500)
      );
      $log.log(label, item.start || item.email, item);
    };

    vm.getUserData = function (idx) {
      vm.activities = [];
      vm.sessions = [];
      if (idx === vm.current) {
        vm.current = -1;
        delete vm.status.activities;
        delete vm.status.sessions;
        return;
      }
      vm.current = idx;
      vm.showLog('User', vm.users[idx]);

      vm.status.activities = 'loading';
      Debug.userActivities(vm.users[idx]._id).then(function (results) {
        vm.status.activities = results.data.length > 0 ? 'ok' : 'none';
        vm.activities = results.data
          .filter(function (act) {
            return act.startTime;
          })
          .map(function (act) {
            return Object.assign(act, {
              start: new Date(act.startTime),
              duration: duration(act),
              track: act.track && act.track.name,
              laps: act.lastLap
            });
          });
      });
      vm.status.sessions = 'loading';
      Debug.userSessions(vm.users[idx]._id).then(function (results) {
        vm.status.sessions = results.data.length > 0 ? 'ok' : 'none';
        vm.sessions = results.data
          .map(function (session) {
            return Object.assign(session, {
              start: new Date(session.startTime),
              duration: duration(session)
            });
          });
      });

    };

    return vm;

    function duration(activity) {
      var result = str2time(activity.lastTime) - str2time(activity.startTime);
      if (result < 0) {
        $log.log('start', activity.startTime, str2time(activity.startTime));
        $log.log('last', activity.lastTime, str2time(activity.lastTime));
      }
      return result;
    }

    function str2time(str) {
      return new Date(str).getTime();
    }

    function statusIcon(status) {
      switch (status) {
        case 'deleted' :
          return { tag: 'deleted_forever', color: 'md-warn' };
        case 'expired' :
          return { tag: 'highlight_off', color: 'md-secondary md-hue-1' };
        case 'test' :
          return { tag: 'help', color: 'md-primary md-hue-1' };
        case 'active' :
          return { tag: 'check_circle', color: 'md-primary' };
        default :
          return { tag: 'error', color: 'md-warn' };
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('skatingApp')
    .controller('ActivitiesController', ActivitiesController);

  /** @ngInject */
  function ActivitiesController ($log, $window, $routeParams, Activities) {
    var vm = this;
    vm.duration = duration
    vm.maxWidth= Math.min(720,$window.innerWidth) - 64;
    vm.opacity = function (time) {
      var d = 1 - (time - vm.data.fit.activity.bestLap) / vm.quartile;
      var m = 0.1
      if (time === vm.data.fit.activity.bestLap) {
        d += m
      }
      d /= 1 + m
      return d > 0 ? d * d : 0
    }

    if ($routeParams.id) {
      Activities.get($routeParams.id).then(function (data) {
        // $log.log(data)
        vm.data = data
        vm.columns = data.fit.columns
        vm.quartile = getQuartile(data.fit.laps
          .filter(function (l) {return l.session})
          .map(function (l) {return l.lapTime}))
        vm.sessions = {
          selected: 0,
          list: data.fit.sessions && data.fit.sessions.map(function (session) {return session.idx})
        }
        vm.onClick = function (points, evt) {
          $log.log(points, evt);
        };
      })
    } else {
      vm.list = Activities.list
    }

    return vm;

    function duration (activity) {
      return str2time(activity.lastTime) - str2time(activity.startTime)
    }

    function str2time (str) {
      return new Date(str).getTime()
    }

    function getQuartile (list) {
      list.sort(function (a, b) { return a - b})
      var d = Math.floor(list.length / 4)
      var r = list.length % 4
      var q1 = list[ d - 1 ] + r * (list[ d ] - list[ d - 1 ]) / 4
      return q1 - list[ 0 ]
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('skatingApp')
    .controller('AccountController', AccountController);

  /** @ngInject */
  function AccountController ($log, $mdDialog, $mdToast, $window, User, Payments) {
    var vm = this
    vm.agreed = false
    vm.payments = Payments
    vm.nearExpire = nearExpire

    vm.submit = function () {
      User.agree();
    }

    vm.extend = function () {
      User.extend().then(function(url) {
        $window.location.href = url
      })
    }

    vm.changeUpdated = function () {
      User.update().then( function() {
        $mdToast.showSimple("De update-status is bijgewerkt.");
      })
    }

    vm.cancel = function (ev) {
      $log.log('cancel')
      var confirm = $mdDialog.confirm()
        .title('Account opzeggen?')
        .ariaLabel('Account opzeggen')
        .targetEvent(ev)
        .ok('Ja, nu opheffen')
        .cancel('Nee');

      $mdDialog.show(confirm).then(function () {
        User.cancel().then(function(response) {
          $log.log(response)
        } );
      });
    }

    return vm;

    function nearExpire(days) {
      if( User && User.currentUser && User.currentUser.account ) {
        var limit = Date.now() + days * 24 * 3600 * 1000;
        return new Date(User.currentUser.account.date) < new Date(limit)
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('skatingApp')
    .run(runBlock);

  /** @ngInject */
  function runBlock() {

  }

})();

(function() {
  'use strict';

  angular
    .module('skatingApp')
    .config(routeConfig);

  function routeConfig($routeProvider) {
    $routeProvider
      .when('/', {
        templateUrl: 'app/static/intro.html',
        controller: 'StaticController',
        controllerAs: 'ctrl'
      })
      .when('/settings', {
        templateUrl: 'app/settings/settings.html',
        controller: 'SettingsController',
        controllerAs: 'settings'
      })
      .when('/simulation/:laps?', {
        templateUrl: 'app/simulation/simulation.html',
        controller: 'SimulationController',
        controllerAs: 'sim'
      })
      .when('/activities/', {
        templateUrl: 'app/activities/activities.html',
        controller: 'ActivitiesController',
        controllerAs: 'ctrl'
      })
      .when('/activities/:id', {
        templateUrl: 'app/activities/activities.detail.html',
        controller: 'ActivitiesController',
        controllerAs: 'ctrl'
      })
      .when('/garmin/', {
        templateUrl: 'app/garmin/garmin.html',
        controller: 'GarminController',
        controllerAs: 'ctrl'
      })
      .when('/mylaps/', {
        templateUrl: 'app/mylaps/mylaps.html',
        controller: 'MylapsController',
        controllerAs: 'ctrl'
      })
      .when('/about', {
        templateUrl: 'app/static/about.html',
        controller: 'StaticController',
        controllerAs: 'ctrl'
      })
      .when('/privacy', {
        templateUrl: 'app/static/privacy.html',
        controller: 'StaticController',
        controllerAs: 'ctrl'
      })
      .when('/conditions', {
        templateUrl: 'app/static/conditions.html',
        controller: 'StaticController',
        controllerAs: 'ctrl'
      })
      .when('/account/', {
        templateUrl: 'app/account/account.html',
        controller: 'AccountController',
        controllerAs: 'account'
      })
      .when('/payments/:paymentId', {
        templateUrl: 'app/payments/payments.html',
        controller: 'PaymentsController',
        controllerAs: 'payments'
      })
      .when('/admin', {
        templateUrl: 'app/message/message.html',
        controller: 'MessageController',
        controllerAs: 'ctrl'
      })
      .when('/debug', {
        templateUrl: 'app/debug/debug.html',
        controller: 'DebugController',
        controllerAs: 'ctrl'
      })
      .otherwise({
        redirectTo: '/'
      });
  }
})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('skatingApp')
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('skatingApp')
    .config(config);

  /** @ngInject */
  function config($logProvider, $httpProvider, $mdThemingProvider, moment) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Enable cookies
    $httpProvider.defaults.withCredentials = true;

    // Configure theme colours
    $mdThemingProvider.theme('default')
      .primaryPalette('blue')
      .accentPalette('red');

    moment.locale('nl');
    moment.updateLocale('nl', {
      weekdaysShort: 'zo_ma_di_wo_do_vr_za'.split('_'),
      monthsShort: 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_')
    });
  }

})()

angular.module("skatingApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/account/account.html","<div id=\"account\"><h1 class=\"md-title md-accent\">Mijn account</h1><mod></mod><log-status></log-status><div ng-show=\"currentUser.email\"><p>Je bent ingelogd via {{currentUser.providerId}} als {{currentUser.displayName}} met het e-mailadres <code>{{currentUser.email}}</code>. Je account is gekoppeld aan dit e-mailadres.</p><div ng-if=\"currentUser.account.status && !currentUser.deleted\"><h2 class=\"md-subhead md-primary\">Account</h2><div ng-switch=\"currentUser.account.status\"><div ng-switch-when=\"test\"><p>Je proefaccount is geldig tot {{currentUser.account.date | formatDate }}.</p></div><div ng-switch-when=\"active\"><p>Je account is geldig tot {{currentUser.account.date | formatDate }}.</p></div><div ng-switch-when=\"expired\"><p>Je account is verlopen sinds {{currentUser.account.date | formatDate }}.</p></div><div ng-switch-when=\"canceled\"><p>Je account is opgezegd op {{currentUser.account.date | formatDate }}.</p></div><h2 class=\"md-subhead md-primary\">Verlengen</h2><div>Voor &euro;7,95 kun je je account verlengen tot <span ng-if=\"currentUser.account.promo\"><md-tooltip>Tijdelijke aanbieding tot {{currentUser.account.promo.promoDate|formatDate}}</md-tooltip><span class=\"strike\">{{ currentUser.account.promo.extensionDate |formatDate }}</span> <span class=\"promo\">{{ currentUser.account.extensionDate |formatDate }}</span></span> <span ng-if=\"!currentUser.account.promo\">{{ currentUser.account.extensionDate |formatDate }}</span>.</div><div><button type=\"button\" class=\"md-button md-raised\" ng-class=\"{\'md-primary\':account.nearExpire(30)}\" ng-click=\"account.extend()\">Verlengen</button></div><h2 class=\"md-subhead md-primary\">Betalingen</h2><div ng-switch=\"account.payments.status\"><div ng-switch-when=\"none\"><button type=\"button\" class=\"md-button md-raised\" ng-click=\"account.payments.update()\">OPhalen</button></div><div ng-switch-when=\"loading\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-switch-when=\"list\" md-whiteframe=\"3\"><table class=\"md-table\"><tr><th>datum</th><th>omschrijving</th><th>bedrag</th></tr><tr ng-repeat=\"item in account.payments.list\"><td>{{ item.date | formatShortDate}}</td><td>{{ item.description }}</td><td class=\"num\">{{ item.amount }}</td></tr></table></div></div><h2 class=\"md-subhead md-primary\">Opheffen</h2><div>Je account stopt automatisch aan het einde van de geldigheidsperiode en wordt niet automatisch verlengd. Als je geen updates meer wilt ontvangen, kun je je account hier opheffen.</div><div><button type=\"button\" class=\"md-button md-accent\" ng-click=\"account.cancel()\">Opheffen</button></div></div></div></div></div>");
$templateCache.put("app/activities/activities.detail.html","<div id=\"activities\"><h1 class=\"md-title md-accent\" ng-if=\"ctrl.data.$resolved\">{{ctrl.data.startTime | localized:\'LL\'}}</h1><mod></mod><md-content ng-if=\"ctrl.data.error\">{{ctrl.data.error}}</md-content><md-content ng-if=\"ctrl.data.$resolved\"><div layout=\"row\" layout-wrap=\"\" layout-align=\"space-between center\" class=\"summary\" ng-init=\"activity=ctrl.data.fit.activity\"><div flex=\"45\" flex-xs=\"100\"><div>Locatie</div><div class=\"value\">{{ctrl.data.track.name }}</div></div><div flex=\"45\" flex-xs=\"100\"><div>Aantal ronden</div><div><span class=\"value\">{{ activity.laps.numLaps }}</span> ({{ activity.laps.numLaps * ctrl.data.trackLength / 1000 | number:1 }} km)</div></div><div flex=\"45\" flex-xs=\"100\"><div>Tijd</div><div class=\"value\">{{ctrl.data.startTime | localized:\'LT\'}}&ndash;{{ctrl.data.lastTime | localized:\'LT\'}}</div></div><div flex=\"45\" flex-xs=\"100\"><div>Actief in intervallen</div><div class=\"value\">{{ activity.sessions.time | formatTime:0 }}</div></div><div flex=\"45\" flex-xs=\"100\"><div>Snelste rondetijd</div><div class=\"value\">{{ activity.bestLap | formatTime:3 }}</div></div><div flex=\"45\" flex-xs=\"100\"><div>Max. snelheid</div><div><span class=\"value\">{{ 3600 * ctrl.data.trackLength / activity.bestLap | number:1}}</span> km/u</div></div><div flex=\"45\" flex-xs=\"100\"><div>Gemiddelde rondetijd</div><div class=\"value\">{{ sessions.avgLap | formatTime:1 }}</div></div><div flex=\"45\" flex-xs=\"100\"><div>Gemiddelde snelheid</div><div><span class=\"value\">{{ 3600 * ctrl.data.trackLength / sessions.avgLap | number:1}}</span> km/u</div></div></div><chart data=\"ctrl.data\"></chart><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-selected=\"1\"><md-tab label=\"Intervallen\" ng-disabled=\"!ctrl.data.fit.sessions\"><md-content class=\"md-padding\"><table class=\"md-table activity-session\"><tr><th class=\"tdl\">Interval</th><th>Starttijd</th><th>#ronden</th><th>Tijd</th><th>Gem. ronde</th><th>Beste ronde</th><th ng-if=\"ctrl.columns.heartRate\">Gem. HS</th><th ng-if=\"ctrl.columns.heartRate\">Max. HS</th><th ng-if=\"ctrl.columns.cadence\">Gem. cadans</th><th ng-if=\"ctrl.columns.cadence\">Max. cadans</th></tr><tr ng-repeat=\"session in ctrl.data.fit.sessions\"><td>{{ $index+1 }}</td><td>{{ session.startTime | localized:\'LTS\' }}</td><td>{{ session.data.numLaps }}</td><td>{{ session.data.numLaps ? (session.data.time | formatTime:2) : \'\' }}</td><td>{{ session.data.numLaps ? (session.data.avgLap | formatTime:2) : \'\' }}</td><td>{{ session.data.numLaps ? (session.data.bestLap | formatTime:2) : \'\' }}</td><td ng-if=\"ctrl.columns.heartRate\">{{ session.data.heartRate.avg}}</td><td ng-if=\"ctrl.columns.heartRate\">{{ session.data.heartRate.max}}</td><td ng-if=\"ctrl.columns.cadence\">{{ session.data.cadence.avg}}</td><td ng-if=\"ctrl.columns.cadence\">{{ session.data.cadence.max}}</td></tr><tr class=\"activity-total\" ng-init=\"sessions=ctrl.data.fit.activity.sessions\"><td class=\"tdl\" colspan=\"2\">Totaal</td><td>{{ sessions.numLaps }}</td><td>{{ sessions.time | formatTime:2 }}</td><td>{{ sessions.avgLap | formatTime:2 }}</td><td>{{ sessions.bestLap | formatTime:2 }}</td><td ng-if=\"ctrl.columns.heartRate\">{{ sessions.heartRate.avg}}</td><td ng-if=\"ctrl.columns.heartRate\">{{ sessions.heartRate.max}}</td><td ng-if=\"ctrl.columns.cadence\">{{ sessions.cadence.avg}}</td><td ng-if=\"ctrl.columns.cadence\">{{ sessions.cadence.max}}</td></tr></table></md-content></md-tab><md-tab label=\"Rondetijden\"><md-content class=\"md-padding\"><table class=\"md-table activity-laps\"><tr><th>Ronde</th><th>Totale tijd</th><th>Rondetijd</th><th title=\"km/u\">Snelheid</th><th ng-if=\"ctrl.columns.heartRate\" title=\"slagen/minuut\">Gem. HS</th><th ng-if=\"ctrl.columns.heartRate\" title=\"slagen/minuut\">Max. HS</th><th ng-if=\"ctrl.columns.cadence\" title=\"slagen/minuut\">Gem. cadans</th><th ng-if=\"ctrl.columns.cadence\" title=\"slagen/minuut\">Max. cadans</th></tr><tr ng-repeat=\"lap in ctrl.data.fit.laps\" ng-class=\"{\'session-break\': lap.session === undefined, \'best-lap\': activity.bestLap === lap.lapTime }\"><td class=\"bar-bg\"><div class=\"bar\" style=\"width:{{ctrl.maxWidth*activity.bestLap/lap.lapTime}}px\">&nbsp;</div>{{ $index+1 }}</td><td>{{ lap.totalTime | formatTime:2 }}</td><td>{{ lap.lapTime | formatTime:2 }}</td><td>{{ lap.speed | number: 2 }}</td><td ng-if=\"ctrl.columns.heartRate\">{{ lap.data.heartRate.avg}}</td><td ng-if=\"ctrl.columns.heartRate\">{{ lap.data.heartRate.max}}</td><td ng-if=\"ctrl.columns.cadence\">{{ lap.data.cadence.avg}}</td><td ng-if=\"ctrl.columns.cadence\">{{ lap.data.cadence.max}}</td></tr></table></md-content></md-tab></md-tabs><p id=\"speed\">De gemiddelde waarden zijn berekend over de ronden binnen een interval. De ronden waarin je een nieuwe interval begonnen bent, tellen niet mee.<br>Bij het bepalen van de snelheid is er van uitgegaan dat je continu de binnenbocht rijdt. De lengte bij deze {{ctrl.data.track.trackLength}}m baan is dan {{ctrl.data.trackLength | number:2}}m.</p></md-content></div>");
$templateCache.put("app/activities/activities.html","<div id=\"activities\"><h1 class=\"md-title md-accent\">Activiteiten</h1><mod></mod><log-status></log-status><p>Een&nbsp;<md-icon class=\"material-icons inline-icon favorite\" title=\"Hartslag informatie\">favorite</md-icon>&nbsp;geeft aan dat hartslaginformatie is opgenomen in de activiteit. Ontbrekende hartslaginformatie kan geïmporteerd worden vanuit <a href=\"#/garmin\">Garmin Connect</a>.</p><p ng-if=\"currentUser.transponder\">Ontbrekende activiteiten kunnen worden geïmporteerd worden vanuit <a href=\"#/mylaps\">MYLAPS</a>.</p><div ng-if=\"currentUser.account && !currentUser.deleted\"><table class=\"md-table activity-list\" ng-init=\"list=ctrl.list()\"><tr><th class=\"tdl\">Starttijd</th><th class=\"tdl\">Locatie</th><th class=\"tdr\"># ronden</th><th class=\"tdr\">Duur</th></tr><tr ng-repeat=\"activity in list\"><td><a href=\"#activities/{{activity._id}}\">{{activity.startTime | localized:\'llll\' }}</a><md-icon class=\"material-icons\" ng-if=\"activity.hasRecord\" title=\"Hartslag informatie\">favorite</md-icon></td><td class=\"tdl\">{{activity.track}}</td><td class=\"tdr\">{{activity.lastLap}}</td><td class=\"tdr\">{{ ::ctrl.duration(activity) | formatTime:0 }}</td></tr></table></div></div>");
$templateCache.put("app/debug/debug.html","<div id=\"debug\"><h1 class=\"md-title md-accent\">Debug</h1><mod></mod><log-status></log-status><div ng-if=\"currentUser.admin\" class=\"md-body-1\"><h2 class=\"md-subhead md-primary\">Search for User</h2><form name=\"userPattern\" ng-submit=\"ctrl.searchUser()\" layout=\"row\" layout-align=\"start start\"><md-input-container><label for=\"user-pattern\">User name or email</label> <input type=\"text\" name=\"user-pattern\" id=\"user-pattern\" ng-model=\"ctrl.userPattern\"></md-input-container><md-button class=\"md-icon-button md-primary\" type=\"submit\" aria-label=\"Submit\"><md-icon class=\"material-icons md-24\">search</md-icon></md-button></form><md-content><spinner ng-show=\"ctrl.status.users===\'loading\'\"></spinner><p ng-show=\"ctrl.status.users===\'none\'\">Geen gebruikers gevonden.</p><md-list flex=\"\" ng-show=\"ctrl.status.users===\'ok\'\"><md-list-item class=\"md-2-line\" ng-repeat=\"user in ctrl.users | filter:ctrl.showCurrent\" ng-click=\"ctrl.getUserData($index)\"><img ng-src=\"{{user.photoUrl}}\" class=\"md-avatar\"><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ user.displayName }}<md-icon class=\"material-icons {{user.icon.color}} md-18\">{{user.icon.tag}}</md-icon></h3><h4>{{ user.email }}</h4></div><div class=\"md-secondary md-list-item-text\" layout=\"column\"><p>{{ user.transponder }}</p><p>{{ user.watchesStr }}</p></div></md-list-item></md-list></md-content><md-content ng-show=\"ctrl.current >= 0\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"Activiteiten\"><spinner ng-show=\"ctrl.status.activities===\'loading\'\"></spinner><p ng-show=\"ctrl.status.activities===\'none\'\">Geen activiteiten gevonden.</p><table class=\"md-table activity-list\" ng-if=\"ctrl.status.activities===\'ok\'\"><tr><th>Start</th><th>Duration</th><th>Track</th><th>Watch</th><th># laps</th><th>Status</th><th>Version</th><th>Link</th></tr><tr ng-repeat=\"act in ctrl.activities\" ng-click=\"ctrl.showLog(\'Activitity\', act)\"><td class=\"tdr\">{{ act.start | localized:\'llll\' }}</td><td class=\"tdr\">{{ act.duration | formatTime:0 }}</td><td class=\"tdl\">{{ act.track }}</td><td class=\"tdl\">{{ act.watch }}</td><td class=\"tdr\">{{ act.laps }}</td><td class=\"tdr\">{{ act.status }}</td><td class=\"tdr\">{{ act.version }}</td><td class=\"tdc\"><a href=\"#/activities/{{act._id}}\" target=\"_blank\"><md-icon class=\"material-icons\">launch</md-icon></a></td></tr></table></md-tab><md-tab label=\"Intervallen\"><spinner ng-show=\"ctrl.status.sessions===\'loading\'\"></spinner><p ng-show=\"ctrl.status.sessions===\'none\'\">Geen intervallen gevonden.</p><table class=\"md-table\" ng-if=\"ctrl.status.sessions===\'ok\'\"><tr><th>Start</th><th>Duration</th><th>Watch</th><th># Log entries</th></tr><tr ng-repeat=\"session in ctrl.sessions\" ng-click=\"ctrl.showLog(\'Session\', session)\"><td class=\"tdr\">{{ session.start | localized:\'llll\' }}</td><td class=\"tdr\">{{ session.duration | formatTime:0 }}</td><td class=\"tdl\">{{ session.watch }}</td><td class=\"tdr\">{{ session.logs.length }}</td></tr></table></md-tab></md-tabs></md-content></div></div>");
$templateCache.put("app/garmin/garmin.html","<div id=\"garmin\"><h1 class=\"md-title md-accent\">Importeren van Garmin Connect</h1><mod></mod><log-status></log-status><div ng-show=\"currentUser.email\"><ol><li>Ga naar de <a href=\"https://connect.garmin.com/modern/activities\" target=\"_blank\">Garmin Connect activiteiten pagina</a>,</li><li>Maak een selectie van je activiteiten, bijvoorbeeld bij \'Type activiteit\' en \'Tijdsperiode\'</li><li>Zorg dat de geselecteerde activiteiten voor iedereen toegankelijk zijn. Dit kun je checken en aanpassen met de optie \'Snel bewerken\'</li><li>Selecteer de hele tabel en kopiëer deze (Ctrl-A, Ctrl-C)</li><li>Plak deze dan in het vlak hieronder (Ctrl-V)</li></ol><p>De activiteiten worden nu automatisch gevonden en gekoppeld met de juiste activiteit in Schaatshorloge. Als die activiteit nog geen hartslaginformatie heeft, is deze aangevinkt. De aangevinkte activiteiten kunnen dan geïmporteerd worden.</p><div class=\"dropbox\" md-whiteframe=\"3\" contenteditable=\"true\" ng-model=\"ctrl.text\" placeholder=\"Plak hier de tekst met Garmin activiteiten.\" ng-change=\"ctrl.onChange()\"></div><p ng-hide=\"ctrl.links.length\">Geen links gevonden.</p><div ng-show=\"ctrl.loading\" layout=\"column\" layout-align=\"start center\" layout-padding=\"\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><p>Dit kan een halve minuut duren&hellip;</p></div><p ng-show=\"currentUser.account.status !== \'active\' && ctrl.hasChecked()\">Om activiteiten te importeren, moet je een actieve (betaalde) account hebben, zie de <a href=\"#/account\">account pagina</a> om te verlengen.</p><div><md-list ng-show=\"ctrl.links.length\"><md-subheader class=\"md-no-sticky\"><div layout=\"row\" layout-align=\"space-between center\"><span>Er zijn {{ctrl.links.length}} activiteiten gevonden</span><md-button class=\"md-raised md-primary\" ng-disabled=\"ctrl.loading || currentUser.account.status !== \'active\' || !ctrl.hasChecked()\" ng-click=\"ctrl.import()\">Importeren</md-button></div></md-subheader><md-list-item ng-repeat=\"link in ctrl.links\" ng-class=\"{\'text-disabled\':!link.info.activity && !link.info.error}\"><p ng-hide=\"link.info.$resolved\">{{ link.link }}</p><p ng-show=\"link.info.error\" class=\"alert md-warn\">{{link.link}}: {{link.info.error}}</p><p ng-show=\"link.info.$resolved && !link.info.error\"><md-button href=\"{{link.link}}\" target=\"_blank\" ng-click=\"ctrl.onClick($event)\" aria-label=\"Activity on Garmin Connect\"><img src=\"/assets/images/garmin-icon.png\"></md-button><md-button ng-href=\"#activities/{{link.info.activity._id}}\" target=\"_blank\" ng-click=\"ctrl.onClick($event)\" aria-label=\"Activity on Schaatshorloge\" ng-disabled=\"!link.info.activity\"><img src=\"/favicon-16x16.png\"></md-button>{{link.info.garmin.name}}, {{link.info.garmin.startTime | localized:\'llll\' }}, <span ng-if=\"link.info.activity\">{{link.info.activity.lastLap}} ronden&nbsp;<md-icon class=\"material-icons\" ng-if=\"link.info.activity.record\" title=\"Hartslag informatie\">favorite</md-icon></span></p><md-checkbox ng-disabled=\"!link.info.activity\" class=\"md-secondary\" ng-model=\"link.checked\"></md-checkbox></md-list-item></md-list></div></div></div>");
$templateCache.put("app/message/message.html","<h1 class=\"md-title md-accent\">Beheerder</h1><div class=\"md-body-1\"><div class=\"message-editor\"><textarea ng-model=\"ctrl.message\"></textarea><div ng-model=\"ctrl.message\" contenteditable=\"true\"></div></div></div>");
$templateCache.put("app/mylaps/mylaps.html","<div id=\"mylaps\"><h1 class=\"md-title md-accent\">Importeren van MYLAPS</h1><mod></mod><log-status></log-status><p ng-show=\"currentUser.email\"></p><p ng-if=\"ctrl.errorMessage\" class=\"alert md-warn\">{{ctrl.errorMessage}}</p><div ng-if=\"ctrl.list.length > 0\"><p ng-if=\"ctrl.more\">Ontbrekende MYLAPS activiteiten vanaf {{ctrl.limit | localized:\'LL\' }}</p><p ng-if=\"!ctrl.more\">Alle ontbrekende MYLAPS activiteiten</p><table class=\"md-table\"><tr><th>Starttijd</th><th>Locatie</th><th>Link</th><th>&nbsp;</th></tr><tr ng-repeat=\"activity in ctrl.list\"><td>{{activity.startTime | localized:\'llll\' }}</td><td>{{activity.location.name }}</td><td><a ng-href=\"https://sporthive.com/Practice/Activity/{{activity.id}}\" target=\"_blank\" title=\"Bekijk activiteit op MYLAPS sporthive\"><md-icon class=\"material-icons md-primary md-18\">launch</md-icon></a></td><td><md-button class=\"md-primary md-raised\" ng-click=\"ctrl.import(activity.id)\">Importeren</md-button></td></tr></table></div><p ng-if=\"ctrl.list.length === 0 && ctrl.limit\">Er zijn geen ontbrekende MYLAPS activiteiten gevonden<span ng-if=\"ctrl.more\">sinds {{ctrl.limit | localized:\'LL\' }}</span>.</p><p class=\"load-more\" ng-if=\"ctrl.more && !ctrl.loading\"><md-button class=\"md-raised\" ng-click=\"ctrl.fetch()\">Eerdere activiteiten zoeken</md-button></p><spinner ng-show=\"ctrl.loading\"></spinner></div>");
$templateCache.put("app/payments/payments.html","<div id=\"payments\"><h1 class=\"md-title md-accent\">Betaling controleren</h1><mod></mod><log-status></log-status><div ng-show=\"currentUser.email\"><div ng-switch=\"payments.status\"><p ng-switch-when=\"loading\">De status wordt opgehaald.</p><p ng-switch-when=\"paid\">De betaling is voltooid.</p><div ng-switch-when=\"timeout\"><p>De status van de betaling is nog niet bijgewerkt.</p><button type=\"button\" class=\"md-button md-raised\" ng-click=\"payments.refetch()\">Opnieuw opvragen</button></div><p ng-switch-default=\"\">De betaling wordt nog verwerkt.</p></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"payments.progress\"><md-progress-circular md-mode=\"payments.progress.mode\"></md-progress-circular></div><p ng-hide=\"payment.progress\">Naar <a href=\"#account\">account pagina</a></p></div></div>");
$templateCache.put("app/simulation/simulation.html","<div id=\"simulation\"><h1 class=\"md-title md-accent\">Rondetijden simuleren</h1><mod></mod><p>Je kunt het passeren van de streep met je MYLAPS ProChip simuleren. De rondetijden en het aantal ronden worden dan weergegeven in de Schaatshorloge App op je Garmin.</p><log-status></log-status><div ng-show=\"currentUser.account && !currentUser.deleted\"><form><div ng-if=\"sim.storage.mode!==\'list\'\"><h2 class=\"md-subhead md-primary\">Instellingen</h2><div><md-radio-group ng-model=\"sim.storage.mode\" class=\"md-primary\" layout=\"row\" ng-change=\"changeMode()\" layout-align=\"space-around center\"><md-radio-button flex=\"30\" ng-repeat=\"opt in sim.options\" ng-value=\"opt.id\">{{ opt.label }}</md-radio-button></md-radio-group></div></div><h2 class=\"md-subhead md-primary\">Bediening</h2><div class=\"controls\" ng-switch=\"sim.storage.mode\"><div ng-switch-when=\"manual\"><div>Klik op LAP om een passage te simuleren. Met RESET begin je een nieuwe sessie. Na vijf minuten zonder passage begint automatisch een nieuwe sessie.</div></div><div ng-switch-when=\"auto\"><div>Stel de rondetijd in, de rondetijd zal max. één seconde langer zijn. Klik op de start knop om te beginnen of te pauzeren en weer door te gaan. Met RESET begin je een nieuwe sessie.<br>Na vijf minuten zonder passage begint automatisch een nieuwe sessie.</div><div layout-padding=\"\"><md-input-container><label>Rondetijd in seconden</label> <input type=\"number\" ng-model=\"sim.storage.auto\" min=\"5\" required=\"\"></md-input-container></div></div><div ng-switch-when=\"list\"><div>Klik op de Start knop om te beginnen.</div></div></div><div layout=\"row\" layout-margin=\"\" layout-align=\"space-around center\"><md-button class=\"md-raised md-accent\" ng-if=\"sim.storage.mode===\'manual\'\" ng-click=\"sim.addLap()\">Lap</md-button><md-button class=\"md-raised md-accent material-icons md-24\" ng-click=\"sim.addLap()\" ng-disabled=\"sim.running\" ng-if=\"sim.storage.mode===\'list\'\">play_arrow</md-button><md-button class=\"md-raised md-accent material-icons md-24\" ng-click=\"sim.toggle()\" ng-if=\"sim.storage.mode===\'auto\'\">{{sim.running ? \'pause\' : \'play_arrow\'}}</md-button><md-progress-circular class=\"md-accent\" ng-class=\"{ \'md-hue-1\': !sim.running }\" md-mode=\"determinate\" md-diameter=\"38\" value=\"{{sim.progress}}\" ng-if=\"sim.storage.mode!==\'manual\'\"></md-progress-circular><md-button class=\"md-raised md-primary md-hue-1\" ng-click=\"sim.reset()\">Reset</md-button></div></form><div id=\"results\"><h2 class=\"md-subhead md-primary\">Resultaten {{ sim.service.data.active ? \'huidige\' : \'laatste\'}} activiteit</h2><div layout=\"row\" layout-align=\"space-between start\"><div flex=\"40\" md-whiteframe=\"3\"><table class=\"md-table\"><tr ng-show=\"sim.service.data.active\"><td>Huidige ronde</td><td class=\"num mono\">{{ sim.thisLap | formatTime:1}}</td></tr><tr><td>Aantal rondes</td><td class=\"num mono\">{{ sim.service.data.laps.length }}</td></tr><tr ng-show=\"sim.service.data.laps.length\"><td>Beste ronde</td><td class=\"num mono\">{{ sim.service.data.bestLap | formatTime:3 }}</td></tr></table></div><div flex=\"55\" md-whiteframe=\"3\"><table class=\"md-table\"><tr><th class=\"num\">Lap</th><th class=\"num\">Lap time</th><th class=\"num\">Total time</th></tr><tr ng-repeat=\"lap in sim.service.data.laps | orderBy : \'-totalTime\' | limitTo : 5\" class=\"mono\"><td class=\"num\">{{ sim.service.data.laps.length - $index }}</td><td class=\"num\">{{ lap.lapTime | formatTime }}</td><td class=\"num\">{{ lap.totalTime | formatTime }}</td></tr></table></div></div></div></div></div>");
$templateCache.put("app/settings/setWatches.html","<p>Als je de eerste keer de Schaatshorloge App opent op je Garmin (of via het menu - account), zal deze een code van acht cijfers tonen. Vul deze cijfers hieronder in.</p><md-list ng-show=\"vm.watches.length\"><md-list-item ng-repeat=\"watch in vm.watches\"><md-icon class=\"material-icons md-primary md-hue-1 md-18\">watch</md-icon><p>{{watch.name}} <span class=\"watch-created\">{{ vm.getTimestamp(watch.id) | localized:\'lll\'}}</span></p><md-button class=\"md-secondary md-icon-button md-warn material-icons md-24\" aria-label=\"Remove watch\" ng-click=\"vm.remove($index)\">close<md-tooltip>{{track.name}} verwijderen</md-tooltip></md-button></md-list-item></md-list>");
$templateCache.put("app/settings/settings.html","<div id=\"settings\"><h1 class=\"md-title md-accent\">Instellingen voor horloge en chip</h1><mod></mod><p>Met deze gegevens kan je Garmin horloge de juiste tijden van de ijsbanen ophalen.</p><log-status></log-status><form name=\"settingsForm\" ng-show=\"settings.user.currentUser.account && !currentUser.deleted\"><h2 class=\"md-subhead md-primary\">Garmin horloge</h2><skate-set-watches watches=\"settings.user.currentUser.watches\"></skate-set-watches><md-input-container><label for=\"watch-code\">Horloge code</label> <input type=\"tel\" name=\"watchCode\" id=\"watch-code\" ng-model=\"settings.watchCode\" ng-model-options=\"{ updateOn: \'default blur\', debounce: { default: 1000, blur: 0 } }\"><div ng-messages=\"settingsForm.watchCode.$error\" style=\"color:red\" role=\"alert\"><div ng-message=\"length\">De code moet uit 8 cijfers bestaan.</div><div ng-message=\"code\">De code kan niet worden gevonden of is verlopen.</div></div></md-input-container><h2 class=\"md-subhead md-primary\"><img src=\"../../assets/images/2x-prochip.png\" width=\"144\" height=\"144\" class=\"pull-right\"> MYLAPS chip</h2><p>Vul hier de code in die op je MYLAPS Pro chip staat.</p><md-input-container><label for=\"transponder\">Transponder ID</label> <input type=\"text\" name=\"transponder\" id=\"transponder\" ng-model=\"settings.user.currentUser.transponder\" ng-model-options=\"{ updateOn: \'default blur\', debounce: { default: 1000, blur: 0 } }\" required=\"\"></md-input-container><div ng-if=\"settings.user.currentUser.activity\"><span ng-show=\"settings.user.currentUser.activity===\'none\'\">Nog geen activiteiten gevonden.</span> <span ng-hide=\"settings.user.currentUser.activity===\'none\'\">Laatste activiteit: {{settings.user.currentUser.activity.location}}, {{ settings.user.currentUser.activity.startTime | localized:\'llll\'}}</span></div></form></div>");
$templateCache.put("app/static/about.html","<ul class=\"submenu hidden-print\"><li><a href=\"/#conditions\">Algemene voorwaarden</a></li><li><a href=\"/#privacy\">Privacy Policy</a></li></ul><h1 class=\"md-title md-accent\">Over Schaatshorloge</h1><div class=\"md-body-1\"><p>De Schaatshorloge App bestaat uit een App voor Garmin sporthorloges en een webdienst die de gegevens voor deze App verzorgt. De App voor Garmin kun je gratis downloaden van de <a href=\"https://apps.garmin.com/nl-NL/apps/482ee631-bf84-4083-915d-59241e71750e\">Connect IQ Store</a>. Voor de webdienst moet je op deze site een account maken en een abonnement nemen.</p><h2 class=\"md-subhead md-primary\">Accounts</h2><p>Tot 1 januari 2017 is de dienst gratis. Daarna moet je een account maken om gebruik te kunnen maken van de dienst. Met een proefaccount kun je de dienst 14 dagen gratis uitproberen, daarna kost deze &euro;7,95 per jaar.</p><h2 class=\"md-subhead md-primary\">Communicatie</h2><p>Bij belangrijke updates zal een e-mailbericht verstuurd worden, voor meer informatie tussendoor kun je kijken op <a href=\"https://www.facebook.com/schaatshorloge/\">Facebook</a>. Dat zou ook een goede plek zijn voor contacten met andere gebruikers.</p><p>Voor ondersteuning kun je terecht op de <a href=\"https://schaatshorloge.freshdesk.com/\">support site</a>, daar vind je antwoord op een groeiend aantal vragen. Als je vraag er niet bijstaat, kun je een ticket openen.</p><p></p><p>Als je de Schaatshorloge App niet meer gebruikt en helemaal geen communicatie meer wilt ontvangen, neem dan ook <a href=\"https://schaatshorloge.freshdesk.com/support/tickets/new\">contact</a> op. Binnenkort zal het ook mogelijk zijn om dit zelf op deze site te regelen.</p><h2 class=\"md-subhead md-primary\">Over HarryOnline</h2><p>Schaatshorloge is gemaakt door <a href=\"http://www.harryonline.nl\">HarryOnline</a>, gevestigd te Buenos Aireshof 46, 2548 HE Den Haag<br>KvK-nummer: 27251733, BTW-identificatienummer: zie factuur</p><p>Om contact op te nemen over de Schaatshorloge App kun je een <a href=\"https://schaatshorloge.freshdesk.com/support/tickets/new\">ticket op de support site</a> maken. Voor overige zaken kun je gebruiken maken van het <a href=\"http://www.harryonline.nl/contact\">contactformulier op HarryOnline</a>.</p></div>");
$templateCache.put("app/static/conditions.html","<ul class=\"submenu hidden-print\"><li><a href=\"/#about\">Over Schaatshorloge</a></li><li><a href=\"/#privacy\">Privacy Policy</a></li></ul><h1 class=\"md-title md-accent\">Algemene Voorwaarden HarryOnline</h1><div id=\"conditions\" class=\"md-body-1\"><p class=\"md-caption hidden-print\"><a href=\"/assets/documents/algemene_voorwaarden_20161228.pdf\" download=\"\"><md-icon class=\"material-icons md-18\" flex=\"1\">file_download</md-icon>Download de algemene voorwaarden</a>.</p><ol><li>Algemeen<ol><li>Deze algemene voorwaarden zijn van toepassing op alle overeenkomsten tussen HarryOnline (inclusief de door HarryOnline geëxploiteerde websites waaronder schaatshorloge.nl, runnermaps.nl en smartersudoku.nl en de bijbehorende applicaties) hierna gezamenlijk te noemen HarryOnline, en haar wederpartijen bij enige overeenkomst hierna te noemen Gebruiker.</li><li>Voor zover hierna wordt gesproken over geleverde zaken of softwarediensten (zoals een account via een website of mobiele applicatie), worden daaronder ook begrepen abonnementen.</li><li>Deze algemene voorwaarden zijn niet van toepassing op overeenkomsten met betrekking tot producten van of via HarryOnline die door Gebruiker rechtstreeks worden gesloten met derden, waaronder begrepen via de app-stores van Apple, Google, Garmin en Pebble.</li></ol></li><li>Identificatie<ul class=\"list-unstyled\"><li>HarryOnline is gevestigd te Buenos Aireshof 46, 2548 HE Den Haag<br>Telefoon 070-3099139<br>E-mailadres: mail@harryonline.net<br>KvK-nummer: 27251733<br>BTW-identificatienummer: zie factuur</li></ul></li><li>Aanbiedingen en prijzen<ol><li>Een aanbieding van HarryOnline die een kennelijke verschrijving en/of vergissing bevat is nietig en leidt niet tot enig rechtsgevolg voor HarryOnline. HarryOnline kan niet aan haar aanbiedingen worden gehouden indien Gebruiker redelijkerwijs kan begrijpen dat de aanbiedingen, dan wel een onderdeel daarvan, een kennelijke vergissing of verschrijving bevat.</li><li>Alle prijzen zijn inclusief BTW, tenzij uitdrukkelijk anders vermeld.</li></ol></li><li>Softwarediensten<ol><li>Indien Gebruiker van HarryOnline softwarediensten afneemt, verstrekt HarryOnline een niet-exclusief, niet-overdraagbaar en strikt persoonlijk gebruiksrecht voor deze softwarediensten aan Gebruiker door middel van toegang tot die diensten via de persoonlijke account van Gebruiker tot wederopzegging daarvan door middel van staking van het gebruik, tenzij uitdrukkelijk anders is bepaald.</li><li>HarryOnline draagt zorg voor bereikbaarheid van de softwarediensten en spant zich in om Gebruiker continue toegang tot de softwarediensten te verschaffen. HarryOnline garandeert niet dat de softwarediensten te allen tijde ononderbroken of volledig beschikbaar zullen zijn.</li><li>HarryOnline draagt zorg voor onderhoud aan de softwarediensten waar door haar noodzakelijk geacht. Indien de softwarediensten door onderhoud niet bereikbaar zijn, zal HarryOnline trachten dit tenminste 48 uur van te voren aan Gebruiker aankondigen door (naar keuze van HarryOnline) daarvan mededeling te doen op de softwarediensten en/of per e-mail.</li></ol></li><li>Betaling, levering en ontbinding<ol><li>Betaling voor softwarediensten door Gebruiker dient altijd vooraf plaats te vinden.</li><li>Levering van softwarediensten geschiedt direct na ontvangst van betaling door het ter beschikking stellen van toegang daartoe via de persoonlijke account aan Gebruiker. Indien de betaling van Gebruiker na ontvangst daarvan door HarryOnline op enige wijze wordt gestorneerd, gerestitueerd of anderszins ongedaan wordt gemaakt door de Gebruiker of door een derde, ontbindt HarryOnline de overeenkomst met de gebruiker en beëindigt HarryOnline de toegang van de Gebruiker tot de softwarediensten met onmiddellijke ingang.</li></ol></li><li>Bedenktijd<ol><li>Voor het gebruik van de softwarediensten geldt een bedenktijd (proefperiode) van 14 dagen vanaf de dag nadat daartoe toegang is verstrekt door HarryOnline via de persoonlijke account van Gebruiker waarna Gebruiker deze softwaredienst kan beëindigen door middel van opzegging via de website of de support desk van HarryOnline, te bereiken via de website of het daartoe bestemde formulier op de contact-pagina van de betreffende website van HarryOnline. De softwaredienst zal door HarryOnline vervolgens niet meer aan Gebruiker ter beschikking worden gesteld en HarryOnline zal de door Gebruiker betaalde aankoopprijs binnen dertig dagen na opzegging door Gebruiker restitueren.</li></ol></li><li>Abonnementen<ol><li>Softwarediensten die worden afgenomen via een abonnement worden afgesloten voor een bepaalde duur en kunnen door Gebruiker niet tussentijds worden beëindigd.</li><li>Na verloop van een overeengekomen abonnementsperiode, worden abonnementen niet automatisch verlengd, tenzij uitdrukkelijk anders is overeengekomen.</li></ol></li><li>Garanties en aansprakelijkheid<ol><li>De door HarryOnline te leveren softwarediensten voldoen aan de gebruikelijke eisen en normen die daaraan op het moment van levering c.q. beschikbaarstelling door middel van toegang tot die dienst redelijkerwijs gesteld kunnen worden en waarvoor zij bij normaal gebruik zijn bestemd. HarryOnline garandeert derhalve niet dat de te leveren producten en softwarediensten geschikt zijn voor het door Gebruiker bestemde gebruik.</li><li>HarryOnline maakt regelmatig (wekelijks en dagelijks) een back-up van alle door haar op haar server opgeslagen tijden en andere gegevens. HarryOnline adviseert Gebruiker te allen tijde zelf zijn gegevens lokaal op te slaan. HarryOnline is derhalve niet aansprakelijk voor het verloren gaan van gegevens of dientengevolge geleden schade. HarryOnline is niet aansprakelijk voor schade ontstaan doordat haar server (met inbegrip van de door haar te leveren softwarediensten) niet bereikbaar is.</li><li>HarryOnline is niet aansprakelijk voor schade die ontstaat doordat een softwaredienst niet beschikbaar is voor Gebruiker, tenzij sprake is van opzet of bewuste roekeloosheid aan de zijde van HarryOnline.</li><li>HarryOnline is niet aansprakelijk voor schade, van welke aard ook, ontstaan doordat HarryOnline is uitgegaan van door of namens Gebruiker verstrekte onjuiste en/of onvolledige gegevens.</li><li>Aansprakelijkheid van HarryOnline voor welke schade dan ook is uitgesloten tenzij er sprake is van opzet of grove schuld. In het geval van consumentenkoop strekt deze beperking niet verder dan die, die is toegestaan ingevolge artikel 7:24 lid 2 BW.</li><li>Indien HarryOnline aansprakelijk is voor enige schade, dan is de aansprakelijkheid van HarryOnline beperkt tot maximaal de waarde van de bestelling, althans tot dat gedeelte van de bestelling waarop de aansprakelijkheid betrekking heeft. De aansprakelijkheid van HarryOnline is verder steeds beperkt tot het bedrag dat haar verzekeraar in voorkomend geval uitkeert.</li></ol></li><li>Intellectuele eigendom<ol><li>Alle rechten van intellectuele eigendom, waaronder begrepen maar niet beperkt auteursrecht en databankrechten op HarryOnline, haar producten of softwarediensten berusten uitsluitend bij HarryOnline of haar licentiegevers. Door het aangaan en uitvoeren van een overeenkomst tussen HarryOnline en Gebruiker worden derhalve geen auteursrechten, merkrechten of andere rechten van intellectuele eigendom op de geleverde producten, softwarediensten, de broncode daarvan of de ontwerpen daarvan of afbeeldingen daarop overgedragen aan Gebruiker. Voor het gebruik van de softwarediensten wordt door HarryOnline aan Gebruiker slechts een gebruiksrecht als omschreven in artikel 3 verstrekt, welk gebruiksrecht op elk moment door HarryOnline kan worden opgezegd door niet langer toegang te verschaffen via de persoonlijke account.</li></ol></li><li>Privacy policy<ol><li>HarryOnline verwerkt de persoonsgegevens van Gebruiker die nodig zijn voor het verlenen van diensten aan Gebruiker. Op deze verwerking van persoonsgegevens is de betreffende Privacy Policy van HarryOnline van toepassing. Gebruiker geeft door het aanmaken van een account toestemming voor de verwerking van zijn persoonsgegevens zoals beschreven in de Privacy Policy.</li></ol></li><li>Toepasselijk recht en geschillen<ol><li>Op alle rechtsbetrekkingen waarbij HarryOnline partij is, is uitsluitend het Nederlands recht van toepassing, ook indien aan een verbintenis geheel of gedeeltelijk in het buitenland uitvoering wordt gegeven of indien de bij de rechtsbetrekking betrokken partij aldaar woonplaats heeft. De toepasselijkheid van het Weens Koopverdrag wordt uitgesloten.</li><li>Partijen zullen pas een beroep op de rechter doen nadat zij zich tot het uiterste hebben ingespannen een geschil in onderling overleg te beslechten.</li></ol></li></ol><p class=\"version-date md-caption\">HarryOnline - Algemene voorwaarden - v.28 dec 2016</p></div>");
$templateCache.put("app/static/intro.html","<h1 class=\"md-title md-accent\">Schaatshorloge - MYLAPS rondetijden op je Garmin</h1><mod></mod><div layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between start\" layout-xs=\"column\" layout-align-xs=\"center center\"><p>Met de Schaatshorloge App kun je tijdens het schaatsen de rondetijden op je sporthorloge zien. Je kunt de app downloaden in de <a href=\"https://apps.garmin.com/nl-NL/apps/482ee631-bf84-4083-915d-59241e71750e\">Connect IQ store</a>.</p><div class=\"iq-badge\"><a href=\"https://apps.garmin.com/nl-NL/apps/482ee631-bf84-4083-915d-59241e71750e\"><img src=\"/assets/images/available-badge.svg\" width=\"250\"></a></div></div><div layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between start\" layout-xs=\"column\" layout-align-xs=\"center center\"><p>Alle gegevens (rondetijden, snelheid, hartslag, cadans) worden op deze site gecombineerd in een grafiek en in tabellen, zodat je thuis je prestaties uitgebreid kunt analyseren. Of direct na afloop op je mobiel.</p><div class=\"skate-graph\"><img src=\"/assets/images/ma0220_250.png\" width=\"250\"></div></div><h2 class=\"md-subhead md-primary\">Hoe werkt dat?</h2><a href=\"https://youtu.be/Ux41ULhY4bQ\" class=\"video-demo pull-right\" ng-click=\"ctrl.showVideo($event)\"><img src=\"/assets/images/demo.jpg\" width=\"250\"></a><p>De MYLAPS ProChip transponder om je enkel registreert iedere keer als je de streep passeert en de rondetijd is vrijwel direct beschikbaar op de MYLAPS website.</p><p>De app haalt deze informatie van MYLAPS en laat binnen enkele seconden je rondetijd zien op het scherm van je Garmin horloge. Je voelt je horloge trillen als de nieuwe tijd verschijnt.</p><h2 class=\"md-subhead md-primary\">Wat heb je hiervoor nodig?</h2><ul><li><p>Allereerst natuurlijk een geschikt Garmin sporthorloge, dat zijn o.a. deze:</p><all-watches layout=\"row\" layout-wrap=\"\"></all-watches><p>De complete lijst staat op de <a href=\"https://apps.garmin.com/nl-NL/apps/482ee631-bf84-4083-915d-59241e71750e\">Connect IQ store</a> pagina: Compatibele toestellen.</p></li><li><p>Daarnaast heb je een <a href=\"https://speedhiveshop.mylaps.com/active-sports/prochip-flex.html\">MYLAPS ProChip</a> nodig, hiermee wordt je tijd geregistreerd.</p></li><li><p>Om de Internet verbinding met je horloge te maken, moet je je mobiele telefoon bij je dragen. Zelf gebruik ik daarvoor een <a href=\"http://www.spibelt.nl/\">SPI-belt</a>, maar er zijn natuurlijk <a href=\"https://www.hardloopzone.nl/beste-running-belt/\">meer mogelijkheden</a>.</p></li><li><p>De ijsbaan waar je schaatst moet een MYLAPS registratiesysteem hebben. De meeste ijsbanen in Nederland hebben dit, zie de <a href=\"https://sporthive.com/practice\">lijst op de MYLAPS site</a>.</p></li><li><p>Een account op deze site om de gegevens van MYLAPS naar je horloge te sturen. Die kun je makkelijk maken door gewoon met een Facebook of Google account in te loggen. Je kunt het twee weken gratis uitproberen, daarna kun je beslissen of je deze wilt verlengen. Dat kost &euro;7,95 per jaar.</p></li></ul><h2 class=\"md-subhead md-primary\">Aan de slag!</h2><ul><li><p>In de <a href=\"https://schaatshorloge.freshdesk.com/support/solutions\">uitgebreide handleiding</a> staat precies beschreven hoe je de App installeert, koppelt met je horloge en je chip, en hoe je de App tijdens het schaatsen kunt gebruiken.</p></li><li><p>Met <a href=\"#simulation\">Simulatie</a> kun je thuis alles uitproberen, zodat je weet hoe het werkt als je op de ijsbaan staat.</p></li><li><p>Na afloop kun je bij <a href=\"#activities\">Activiteiten</a> alle details terugvinden: rondetijden, intervallen, hartslag, cadans (als je horloge dit ondersteunt).</p></li></ul><div layout=\"row\" layout-padding=\"\" md-whiteframe=\"1\"><a href=\"http://schaatshorloge.freshdesk.com\" flex=\"1\"><md-icon class=\"material-icons md-primary md-hue-1 md-36\" flex=\"1\">help</md-icon></a><div flex=\"\">Feedback, suggesties, vragen?<br>Ga naar <a href=\"http://schaatshorloge.freshdesk.com\">schaatshorloge.freshdesk.com</a>.</div></div>");
$templateCache.put("app/static/privacy.html","<ul class=\"submenu hidden-print\"><li><a href=\"/#about\">Over Schaatshorloge</a></li><li><a href=\"/#conditions\">Algemene voorwaarden</a></li></ul><h1 class=\"md-title md-accent\">Privacy Policy HarryOnline</h1><div class=\"md-body-1\"><p class=\"md-caption hidden-print\"><a href=\"/assets/documents/privacy_policy_20170103.pdf\" download=\"\"><md-icon class=\"material-icons md-18\" flex=\"1\">file_download</md-icon>Download de Privacy Policy</a></p><p>Via de website www.schaatshorloge.nl worden privacygevoelige gegevens oftewel persoonsgegevens verwerkt. HarryOnline acht een zorgvuldige omgang met persoonsgegevens van groot belang. Persoonlijke gegevens worden door ons dan ook zorgvuldig verwerkt en beveiligd.</p><p>Bij onze verwerking houden wij ons aan de eisen die de Wet bescherming persoonsgegevens (Wbp) stelt. Dat betekent onder andere dat wij:</p><ul><li><strong>duidelijk vermelden</strong> met <strong>welke doeleinden</strong> wij persoonsgegevens verwerken. Dat doen wij via deze Privacy Policy;</li><li>onze <strong>verzameling van persoonsgegevens beperken</strong> tot alleen de persoonsgegevens die nodig zijn voor legitieme doeleinden;</li><li>u eerst <strong>vragen om uitdrukkelijke toestemming</strong>om uw persoonsgegevens te verwerken in gevallen waarin uw toestemming is vereist;</li><li><strong>passende beveiligingsmaatregelen nemen</strong>om uw persoonsgegevens te beschermen en dat ook eisen van partijen die in onze opdracht persoonsgegevens verwerken;</li><li>uw recht respecteren om uw <strong>persoonsgegevens op uw aanvraag ter inzage te bieden, te corrigeren of te verwijderen</strong>.</li></ul><p>HarryOnline is de verantwoordelijke voor de gegevensverwerking. In deze Privacy Policy leggen wij uit welke persoonsgegevens wij verzamelen en gebruiken en met welk doel. Wij raden u aan deze zorgvuldig te lezen.</p><p>Deze Privacy Policy is voor het laatst aangepast op 3 jan 2017.</p><h2 class=\"md-subhead md-primary\">Gebruik van persoonsgegevens</h2><p>Door het gebruiken van onze dienst laat u bepaalde gegevens bij ons achter. Dat kunnen persoonsgegevens zijn. Wij bewaren en gebruiken uitsluitend de persoonsgegevens die rechtstreeks door u worden opgegeven, in het kader van de door u gevraagde dienst, of waarvan bij opgave duidelijk is dat ze aan ons worden verstrekt om te verwerken.</p><p>Wij gebruiken de volgende gegevens voor de in deze Privacy Policy genoemde doelen: - NAW gegevens - Factuuradres - Emailadres - Betalingsgegevens - uw (profiel-) foto</p><h2 class=\"md-subhead md-primary\">Registreren</h2><p>Bij bepaalde onderdelen van onze dienst moet u zich eerst registreren. Na registratie bewaren wij via de door u gekozen gebruikersnaam de door u opgegeven persoonsgegevens. Wij bewaren deze gegevens zodat u deze niet elke keer opnieuw hoeft in te vullen, zodat wij u kunnen contacteren in het kader van uitvoering van de overeenkomst, facturering en betaling en om een overzicht te geven van de producten en diensten die u bij ons heeft afgenomen.</p><p>Wij zullen de aan uw gebruikersnaam gekoppelde gegevens niet aan derden verstrekken, tenzij dat noodzakelijk is in het kader van de uitvoering van de overeenkomst die u met ons sluit of indien dit wettelijk verplicht is. In geval van een vermoeden van fraude of misbruik van onze website kunnen wij persoonsgegevens aan de bevoegde autoriteiten overhandigen.</p><h2 class=\"md-subhead md-primary\">Toegang website</h2><p>Met onze website kunt u toegang krijgen tot een beheeromgeving waar u zelf zaken kunt instellen, opgeven en wijzigen.</p><h2 class=\"md-subhead md-primary\">Een abonnement afsluiten</h2><p>Via www.schaatshorloge.nl kunt u een betaald abonnement afsluiten.</p><h2 class=\"md-subhead md-primary\">Reclame</h2><p>Wij kunnen u, naast de informatie op onze website, op de hoogte brengen van onze nieuwe producten en diensten per e-mail</p><h2 class=\"md-subhead md-primary\">Contactformulier</h2><p>Als u een contactformulier op de website invult, of ons een e-mail stuurt, dan worden de gegevens die u ons toestuurt bewaard zolang als naar de aard van het formulier of de inhoud van uw e-mail nodig is voor de volledige beantwoording en afhandeling daarvan.</p><h2 class=\"md-subhead md-primary\">App store</h2><p>De app die de dienst levert, is gedownload via een appstore van derden. Wij hebben geen invloed op welke persoonsgegevens de aanbieder hiervan verwerkt en waarvoor. Wij raden u aan de relevante Privacy Policyen te lezen van de desbetreffende aanbieder.</p><h2 class=\"md-subhead md-primary\">Publicatie</h2><p>Wij publiceren uw klantgegevens niet.</p><h2 class=\"md-subhead md-primary\">Verstrekking aan derden</h2><p>Uw gegevens worden uitdrukkelijk niet aan derden verstrekt.</p><h2 class=\"md-subhead md-primary\">Google Analytics</h2><p>Wij gebruiken Google Analytics om bij te houden hoe bezoekers onze website gebruiken. Wij hebben een bewerkersovereenkomst met Google gesloten om afspraken te maken over de omgang met onze data. Verder hebben wij Google niet toegestaan de verkregen Analytics informatie te gebruiken voor andere Google diensten, tot slot laten wij de IP-adressen anonimiseren.</p><h2 class=\"md-subhead md-primary\">Beveiliging</h2><p>Wij nemen beveiligingsmaatregelen om misbruik van en ongeautoriseerde toegang tot persoonsgegevens te beperken.</p><h2 class=\"md-subhead md-primary\">Websites van derden</h2><p>Deze Privacy Policy is niet van toepassing op websites van derden die door middel van links met deze website zijn verbonden. Wij kunnen niet garanderen dat deze derden op een betrouwbare of veilige manier met uw persoonsgegevens omgaan. Wij raden u aan de Privacy Policy van deze websites te lezen alvorens van deze websites gebruik te maken.</p><h2 class=\"md-subhead md-primary\">Wijzigingen in deze Privacy Policy</h2><p>Wij behouden ons het recht voor om wijzigingen aan te brengen in deze Privacy Policy. Het verdient aanbeveling om deze Privacy Policy geregeld te raadplegen, zodat u van deze wijzigingen op de hoogte bent.</p><h2 class=\"md-subhead md-primary\">Inzage en wijzigen van uw gegevens</h2><p>Voor vragen over ons privacybeleid of vragen omtrent inzage en wijzigingen in (of verwijdering van) uw persoonsgegevens kunt u te allen tijde contact met ons opnemen via onderstaande gegevens:</p><address>Buenos Aireshof 46, 2548 HE Den Haag<br>Telefoon: 070-3099139<br>E-mailadres: mail@harryonline.net</address><p class=\"version-date md-caption\">HarryOnline - Privacy Policy - v.3 jan 2017</p></div>");
$templateCache.put("app/static/video.html","<md-dialog aria-label=\"Video demo\"><form ng-cloak=\"\"><md-dialog-content><md-button class=\"md-icon-button pull-right\" ng-click=\"cancel()\"><md-icon class=\"material-icons md-18\">close</md-icon></md-button><div class=\"md-dialog-content\"><iframe width=\"640\" height=\"360\" src=\"https://www.youtube.com/embed/Ux41ULhY4bQ?rel=&amp;autoplay=1\" frameborder=\"0\" allowfullscreen=\"\"></iframe></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/components/footer/siteLinks.html","<ul><li><a href=\"http://schaatshorloge.freshdesk.com/\">Contact/support</a></li><li><a href=\"#about\">Over deze site</a><md-tooltip md-direction=\"top\">accounts, privacy</md-tooltip></li></ul>");
$templateCache.put("app/components/footer/social.html","<ul><li><a href=\"https://www.facebook.com/schaatshorloge/\"><img src=\"assets/images/facebook-square.svg\" alt=\"Facebook\"></a></li><li><a href=\"https://twitter.com/schaatshorloge\"><img src=\"assets/images/twitter-square.svg\" alt=\"Twitter\"></a></li></ul>");
$templateCache.put("app/components/chart/chart.html","<canvas class=\"chart chart-line\" chart-data=\"selectedData\" chart-labels=\"labels\" chart-options=\"options\" chart-dataset-override=\"datasetOverride\" chart-click=\"onClick\"></canvas><div class=\"chart-options\"><md-select ng-show=\"sessionsList\" class=\"session-select\" aria-label=\"Select session\" ng-model=\"sessionSelect\" ng-change=\"setSelectedSession()\"><md-option value=\"0\">Alle intervallen</md-option><md-option ng-repeat=\"id in sessionsList\" value=\"{{id}}\">Interval {{id}}</md-option></md-select><div flex=\"\" layout-gt-xs=\"row\" layout-xs=\"column\" layout-align=\"space-around start\" layout-padding=\"\"><md-checkbox ng-if=\"legend.length > 1\" ng-repeat=\"item in legend\" ng-model=\"dataSelect[item.key]\" aria-label=\"{{item.label}}\" class=\"md-primary\" ng-change=\"setSelectedData()\"><span style=\"color:{{item.color}}\">{{item.label}}</span></md-checkbox><span ng-if=\"legend.length === 1\" style=\"color:{{legend[0].color}}\">{{legend[0].label}}</span></div></div>");
$templateCache.put("app/components/auth/accept.html","<md-dialog aria-label=\"Account maken\" class=\"accept-dialog\" ng-cloak=\"\"><md-toolbar class=\"md-hue-1\"><div class=\"md-toolbar-tools\"><h2>Account maken</h2><span flex=\"\"></span><md-button class=\"md-icon-button close-icon\" aria-label=\"Close\" ng-click=\"cancel()\"></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content md-body-1\"><p>Met dit formulier kun je je aanmelden bij Schaatshorloge. Je kunt Schaatshorloge eerst twee weken gratis uitproberen, daarna kun je beslissen of je een abonnement wilt nemen (&euro; 7,95 per jaar).</p><form ng-submit=\"account.submit()\" layout-padding=\"\"><div><md-checkbox ng-model=\"account.agreed\" aria-label=\"agree\" required=\"\"></md-checkbox>Ik ga akkoord met de <a href=\"/#conditions\">Algemene Voorwaarden</a> en de <a href=\"/#privacy\">Privacy Policy</a>.</div><div><button type=\"submit\" ng-disabled=\"!account.agreed\" class=\"md-button md-raised md-primary\">Account maken</button></div></form></div></md-dialog-content></md-dialog>");
$templateCache.put("app/components/auth/authmenu.html","<md-menu-bar class=\"auth-menu\"><md-button ng-if=\"currentUser===false\" ng-click=\"auth.login()\" aria-label=\"Open login dialog\">Log in</md-button><md-menu md-offset=\"0 4\" ng-if=\"currentUser\"><md-button ng-click=\"$mdOpenMenu($event)\" class=\"md-image-button\" aria-label=\"User submenu\"><md-icon ng-hide=\"imageLoaded\" class=\"material-icons md-36\">person</md-icon><img class=\"avatar\" ng-src=\"{{currentUser.photoUrl}}\" sb-load=\"imageLoaded=true\" ng-show=\"imageLoaded\"></md-button><md-menu-content width=\"2\" md-position-mode=\"target-right target\"><md-menu-item><md-button ng-click=\"auth.account()\" aria-label=\"My account\">Mijn account</md-button></md-menu-item><md-menu-item><md-button ng-click=\"auth.signOut()\" aria-label=\"Log out\">Afmelden</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>");
$templateCache.put("app/components/auth/login.html","<md-dialog aria-label=\"Aanmelden\" class=\"login-dialog\" ng-cloak=\"\"><md-toolbar class=\"md-hue-1\"><div class=\"md-toolbar-tools\"><h2>Aanmelden</h2><span flex=\"\"></span><md-button class=\"md-icon-button close-icon\" aria-label=\"Close\" ng-click=\"cancel()\"></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content md-body-1\"><p>Je kunt je aanmelden met een Facebook of Google account.</p><p>Als je geen van beide hebt, kun je een <a href=\"https://accounts.google.com/SignUpWithoutGmail\" target=\"_blank\">Google account maken<i class=\"material-icons\">launch</i></a> met je bestaande e-mailadres.</p><div layout=\"row\" layout-align=\"space-around\" layout-wrap=\"\"><md-button class=\"md-raised\" ng-click=\"loginWith(\'facebook\')\" aria-label=\"Log in with Facebook\"><svg width=\"22\" height=\"22\" viewbox=\"0 0 1792 1792\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1376 128q119 0 203.5 84.5t84.5 203.5v960q0 119-84.5 203.5t-203.5 84.5h-188v-595h199l30-232h-229v-148q0-56 23.5-84t91.5-28l122-1v-207q-63-9-178-9-136 0-217.5 80t-81.5 226v171h-200v232h200v595h-532q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960z\" fill=\"#3b5999\"></path></svg>Facebook</md-button><md-button class=\"md-raised\" ng-click=\"loginWith(\'google\')\" aria-label=\"Log in with Google\"><svg width=\"22\" height=\"22\" viewbox=\"0 0 1792 1792\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1045 905q0-26-6-64h-362v132h217q-3 24-16.5 50t-37.5 53-66.5 44.5-96.5 17.5q-99 0-169-71t-70-171 70-171 169-71q92 0 153 59l104-101q-108-100-257-100-160 0-272 112.5t-112 271.5 112 271.5 272 112.5q165 0 266.5-105t101.5-270zm345 46h109v-110h-109v-110h-110v110h-110v110h110v110h110v-110zm274-535v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z\" fill=\"#dd4b39\"></path></svg>Google</md-button></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/components/auth/logstatus.html","<div><spinner ng-show=\"currentUser === undefined\"></spinner><p ng-if=\"currentUser === false\" ng-init=\"login()\">{{ message }}</p><p ng-if=\"currentUser && !currentUser.account\" ng-init=\"accept()\">Dit kan alleen als je een account hebt. <a href=\"#account\">Maak een account</a>.</p><p ng-if=\"currentUser && currentUser.deleted\" class=\"md-warn\">Het account dat bij je e-mailadres hoort is opgeheven.</p></div>");
$templateCache.put("app/components/navbar/navbar.html","<div layout=\"row\" layout-align=\"center center\"><div layout=\"row\" class=\"limit-width\" layout-align=\"space-between center\"><md-nav-bar md-selected-nav-item=\"currentNavbarPage\" aria-label=\"Main navigation\" flex=\"\"><md-nav-item md-nav-click=\"goto(\'/\')\" name=\"intro\" class=\"logo\" aria-label=\"Intro page\"><img src=\"assets/images/icon_track_wt_38.png\" class=\"navbar-logo\"></md-nav-item><md-nav-item md-nav-click=\"goto(\'/settings\')\" name=\"settings\">Instellingen</md-nav-item><md-nav-item md-nav-click=\"goto(\'/simulation\')\" name=\"simulation\">Simulatie</md-nav-item><md-nav-item md-nav-click=\"goto(\'/activities\')\" name=\"activities\">Activiteiten</md-nav-item></md-nav-bar><auth-menu></auth-menu></div></div>");
$templateCache.put("app/components/tracks/trackline.html","<span>{{vm.track.name}}<md-tooltip>Track ID {{vm.track.id}}</md-tooltip></span>, <span>{{vm.track.country}}<md-tooltip ng-if=\"vm.country\">{{vm.country}}</md-tooltip></span> <a href=\"{{vm.track.link}}\" target=\"blank\"><md-icon class=\"material-icons md-primary md-hue-1 md-18\">launch</md-icon><md-tooltip>Laatste trainingsresultaten op MYLAPS</md-tooltip></a>");
$templateCache.put("app/components/watches/allWatches.html","<md-list><md-list-item ng-repeat=\"watch in watches\" ng-href=\"{{watch.link}}\"><div class=\"md-avatar\"><img ng-src=\"/assets/images/watches/sz48/{{watch.id}}.png\" alt=\"{{label}}\"></div><p>{{watch.label}}</p></md-list-item></md-list>");}]);